export const UI_TRANSLATIONS: { en: Record<string, string> } = {
  en: {
    "Не удалось сохранить выбор карты. Попробуйте ещё раз.": "Could not save your card selection. Please try again.",
    "Статистика": "Statistics",
    "Пересмотры": "Rewatches",
    "Мои итоги": "My Results",
    "Друзья": "Friends",
    "Мои списки": "My Lists",
    "Что посмотреть": "What to Watch",
    "Путешествия": "Journeys",
    "На этой неделе доступна легендарная карта": "A legendary card is available this week",
    "На этой неделе доступна легендарная экспедиция": "A legendary expedition is available this week",
    "На этой неделе доступны легендарная карта и экспедиция": "A legendary card and expedition are available this week",
    "Достижения": "Achievements",
    "Дневник": "Diary",
    "События": "Notifications",
    "Источники данных": "Data Sources",
    "Источники данных TMDB": "TMDB Data Sources",
    "Фильм или персона": "Movie or person",
    "фильм или персона": "movie or person",
    "Показать все результаты ...": "Show all results ...",
    "Ничего не найдено.": "Nothing found.",
    "Нет постера": "No poster",
    "Нет фото": "No photo",
    "Нет данных": "No data",
    "Дата неизвестна": "Date unknown",
    "Неизвестно": "Unknown",
    "Дата не указана": "Date not specified",
    "Неизвестный фильм": "Unknown movie",
    "Место не указано": "Place not specified",
    "Год неизвестен": "Year unknown",
    "Жанр не указан": "Genre not specified",
    "Страна не указана": "Country not specified",
    "Роль не указана": "Role not specified",
    "Участие не указано": "Participation not specified",
    "Показать полностью": "Show more",
    "Закрыть": "Close",
    "Поиск": "Search",
    "Поиск по имени": "Search by name",
    "Очистить поиск": "Clear search",
    "Участники с таким именем не найдены.": "No crew members found with that name.",
    "Активные фильтры": "Active filters",
    "Сбросить все": "Clear all",
    "буду смотреть": "watchlist",
    "О профиле": "About profile",
    "Фильм": "Movie",
    "Сериал": "Series",
    "Персона": "Person",
    "Получено": "Earned",
    "В процессе": "In progress",
    "Разделы журнала": "Journal sections",
    "Загружаем ещё...": "Loading more...",
    "оценка": "rating",
    "Профиль не найден": "Profile not found",
    "Кино": "Cinema",
    "Актёрское мастерство": "Acting",
    "Режиссура": "Directing",
    "Сценарий": "Writing",
    "Продюсирование": "Production",
    "Музыка и звук": "Music and sound",
    "Операторская работа": "Camera",
    "Монтаж": "Editing",
    "Художественный отдел": "Art department",
    "Костюмы и грим": "Costume and makeup",
    "Съёмочная группа": "Crew",
    "Известен по:": "Known for:",

    "Настройки": "Settings",
    "Цветовая схема": "Color theme",
    "Фон приложения": "App background",
    "Загрузить изображение": "Upload image",
    "Обработка…": "Processing...",
    "Импорт оценок и списков": "Import ratings and lists",
    "Язык интерфейса": "Interface language",
    "Приватность профиля": "Profile privacy",
    "Кто может видеть мой профиль": "Who can see my profile",
    "Все пользователи": "Everyone",
    "Только друзья": "Friends only",
    "Никто": "Nobody",
    "Изменение применяется сразу ко всем ссылкам и разделам профиля.": "The change applies immediately to every profile link and section.",
    "Проверяем доступ к профилю...": "Checking profile access...",
    "Профиль доступен только друзьям": "This profile is available to friends only",
    "Добавьте пользователя в друзья, чтобы получить доступ к его профилю.": "Add this user as a friend to access their profile.",
    "Этот профиль закрыт": "This profile is private",
    "Пользователь ограничил доступ к своим оценкам, статистике и активности.": "The user has restricted access to their ratings, statistics, and activity.",
    "Вернуться назад": "Go back",
    "Заявка отправлена": "Request sent",
    "Вы уже друзья": "You are already friends",
    "Не удалось отправить заявку в друзья": "Could not send the friend request",
    "Просмотр закрытого профиля в административном режиме": "Viewing a private profile in administrator mode",
    "Ваш профиль закрыт. Другие пользователи не видят ваши оценки, статистику и активность.": "Your profile is private. Other users cannot see your ratings, statistics, or activity.",
    "Ваш профиль доступен только подтверждённым друзьям.": "Your profile is available only to confirmed friends.",
    "Введите имя или UID": "Enter a name or UID",
    "Доступ только для друзей": "Friends-only access",
    "Закрытый профиль": "Private profile",
    "Загрузка": "Loading",
    "Загружаем сохранённый прогресс испытаний…": "Loading saved challenge progress…",
    "Интерфейс и уведомления": "Interface and notifications",
    "Выберите, какие необязательные элементы показывать.": "Choose which optional interface elements to show.",
    "Поздравительные окна": "Celebration dialogs",
    "Достижения, испытания и важные повышения уровня.": "Achievements, challenges, and important level-ups.",
    "Всплывающие сообщения": "Toast notifications",
    "Короткие сообщения в правом верхнем углу.": "Brief messages in the top-right corner.",
    "Активность друзей": "Friend activity",
    "Новые оценки, достижения и другие события друзей.": "New ratings, achievements, and other friend activity.",
    "Легендарное свечение": "Legendary highlights",
    "Золотая рамка «Путешествий», карт недели и экспедиций.": "The golden frame around Journeys, weekly cards, and expeditions.",
    "Счётчик новых событий": "New event badge",
    "Цифра непрочитанных событий рядом с «Дневником».": "The unread event count next to Diary.",
    "Анимации и эффекты": "Animations and effects",
    "Декоративные переходы, сияние и эффекты открытия.": "Decorative transitions, glow, and reveal effects.",
    "Окна, требующие решения, например запросы в друзья и подтверждения, остаются включены.": "Dialogs that require a decision, such as friend requests and confirmations, remain enabled.",
    "Русский": "Russian",
    "English": "English",
    "Изумрудный": "Emerald",
    "Лавандовый": "Lavender",
    "Морской": "Ocean",
    "Карамельный": "Caramel",
    "Bubblegum": "Bubblegum",
    "Гранатовый": "Pomegranate",
    "выход": "Sign out",
    "Вернуться в мой профиль.": "Back to my profile.",
    "Профиль": "Profile",
    "Закрыть меню": "Close menu",
    "Открыть меню": "Open menu",
    "Меню": "Menu",
  "Свернуть": "Collapse",
  "Развернуть": "Expand",
  "Свернуть фильтры": "Collapse filters",
  "Развернуть фильтры": "Expand filters",

    "Фильтры": "Filters",
    "Введите название фильма": "Enter movie title",
    "Введите название фильма, чтобы добавить свою первую оценку.": "Enter a movie title to add your first rating.",
    "Выберите первое испытание и превратите просмотр фильмов в приключение.": "Choose your first challenge and turn watching movies into an adventure.",
    "Не знаете, что посмотреть? Начните с готовых подборок.": "Not sure what to watch? Start with curated collections.",
    "Сбросить фильтры": "Reset filters",
    "Фильтр по жанрам": "Filter by genres",
    "Исключить жанры": "Exclude genres",
    "Не": "Not",
    "Скрыть короткометражные фильмы": "Hide short films",
    "Без короткометражек": "No short films",
    "Фильтр по странам": "Filter by countries",
    "Диапазон по годам": "Year range",
    "Диапазон по оценкам": "Rating range",
    "Диапазон по моим оценкам": "My rating range",
    "с года": "from year",
    "по год": "to year",
    "от": "from",
    "до": "to",
    "Буду смотреть": "Watchlist",
    "Любимые фильмы": "Favorite Movies",
    "Личный топ": "My Top",
    "Антитоп": "Bottom List",
    "Топ-10 фильмов": "Top 10 Movies",
    "Топ-10 фильмов и сериалов": "Top 10 Movies and Series",
    "Антитоп-10 фильмов и сериалов": "Bottom 10 Movies and Series",
    "Расставьте любимые фильмы по местам — от первого до десятого.": "Rank your favorite movies from first to tenth.",
    "Расставьте любимые фильмы и сериалы по местам — от первого до десятого.": "Rank your favorite movies and series from first to tenth.",
    "Личный рейтинг любимых фильмов пользователя.": "The user's personal ranking of favorite movies.",
    "Личный рейтинг любимых фильмов и сериалов пользователя.": "The user's personal ranking of favorite movies and series.",
    "Расставьте фильмы и сериалы, которые разочаровали больше всего — от худшего к менее плохому.": "Rank the movies and series that disappointed you most, from worst to less bad.",
    "Личный антитоп фильмов и сериалов пользователя.": "The user's personal bottom ranking of movies and series.",
    "Добавить оценённый фильм": "Add a Rated Movie",
    "Найти среди оценённых фильмов": "Search Rated Movies",
    "В топ можно добавить до 10 оценённых фильмов.": "You can add up to 10 rated movies to your top list.",
    "Добавить фильм": "Add a Movie",
    "Добавить фильм или сериал": "Add a Movie or Series",
    "Найти фильм по названию": "Search for a Movie by Title",
    "Найти фильм или сериал по названию": "Search for a Movie or Series by Title",
    "Найдите любой фильм в каталоге или выберите из оценённых.": "Find any movie in the catalog or choose one you've rated.",
    "Найдите любой фильм или сериал в каталоге либо выберите из оценённых.": "Find any movie or series in the catalog, or choose one you've rated.",
    "Ищем фильмы…": "Searching for Movies…",
    "Не удалось выполнить поиск. Попробуйте ещё раз.": "Could not search for movies. Please try again.",
    "Подходящих фильмов не найдено.": "No matching movies found.",
    "Подходящих фильмов и сериалов не найдено.": "No matching movies or series found.",
    "Загружаем оценённые фильмы…": "Loading Rated Movies…",
    "Загружаем оценённые фильмы и сериалы…": "Loading Rated Movies and Series…",
    "Все десять мест заполнены. Освободите место, чтобы добавить другой фильм или сериал.": "All ten spots are filled. Remove a title to add another one.",
    "Подходящих оценённых фильмов не найдено.": "No matching rated movies found.",
    "Оцените фильмы, чтобы добавить их в личный топ.": "Rate movies to add them to your personal top list.",
    "Оцените фильмы или сериалы, чтобы добавить их в личный топ.": "Rate movies or series to add them to your personal top list.",
    "Добавить в топ": "Add to Top",
    "Добавить в антитоп": "Add to Bottom List",
    "Личный топ фильмов": "Personal Movie Top",
    "Личный топ фильмов и сериалов": "Personal Movie and Series Top",
    "Личный антитоп фильмов и сериалов": "Personal Movie and Series Bottom List",
    "Место": "Rank",
    "Открыть фильм": "Open Movie",
    "Открыть фильм или сериал": "Open Movie or Series",
    "Поднять выше": "Move Up",
    "Опустить ниже": "Move Down",
    "Перетащить на другое место": "Drag to Another Position",
    "Свернуть добавление фильмов": "Collapse Movie Picker",
    "Развернуть добавление фильмов": "Expand Movie Picker",
    "Убрать из топа": "Remove from Top",
    "Убрать из антитопа": "Remove from Bottom List",
    "Первые места личного топа": "Top Personal Picks",
    "Три главных фильма": "Top Three Movies",
    "Три главных фильма и сериала": "Top Three Movies and Series",
    "Личный топ пока пуст": "Personal Top Is Empty",
    "Составить личный топ": "Build Your Personal Top",
    "Открыть весь личный топ": "Open Full Personal Top",
    "Смотреть весь топ": "View Full Top",
    "Свернуть личный топ": "Collapse Personal Top",
    "Развернуть личный топ": "Expand Personal Top",
    "Поделиться личным топом": "Share Personal Top",
    "Ссылка на личный топ скопирована": "Personal top link copied",
    "Не удалось подготовить ссылку личного топа": "Could not prepare the personal top link",
    "Карточка личного топа": "Personal Top Card",
    "Карточка личного топа CineParagon": "CineParagon Personal Top Card",
    "МОЙ ЛИЧНЫЙ ТОП": "MY PERSONAL TOP",
    "Три фильма, которые я ставлю выше всех": "The Three Movies I Rank Above All",
    "Мой личный кинопантеон": "My Personal Movie Pantheon",
    "Ваш личный топ пока пуст.": "Your personal top list is empty.",
    "У этого пользователя пока нет личного топа.": "This user does not have a personal top list yet.",
    "Ваш антитоп пока пуст.": "Your bottom list is empty.",
    "У этого пользователя пока нет антитопа.": "This user does not have a bottom list yet.",
    "Оцените фильмы или сериалы, чтобы добавить их в антитоп.": "Rate movies or series to add them to your bottom list.",
    "Выберите первый фильм или сериал слева — позже порядок можно изменить.": "Choose the first movie or series on the left — you can reorder it later.",
    "Загляните сюда позже.": "Check back later.",
    "Загружаем личный топ…": "Loading Personal Top…",
    "Загружаем антитоп…": "Loading Bottom List…",
    "Сохраняем топ…": "Saving Top…",
    "Сохраняем антитоп…": "Saving Bottom List…",
    "Не удалось загрузить личный топ.": "Could not load the personal top list.",
    "Не удалось загрузить антитоп.": "Could not load the bottom list.",
    "Не удалось сохранить личный топ. Попробуйте ещё раз.": "Could not save the personal top list. Please try again.",
    "Не удалось сохранить антитоп. Попробуйте ещё раз.": "Could not save the bottom list. Please try again.",
    "Добавить в буду смотреть": "Add to watchlist",
    "Удалить из списка буду смотреть": "Remove from watchlist",
  "Добавить в любимые": "Add to favorites",
  "Удалить из любимых": "Remove from favorites",
  "Удалить из списка": "Remove from list",
  "любимых": "favorites",
  "Фильм добавлен в список любимых": "Movie added to favorites.",
  "Фильм удалён из списка": "Movie removed from",
  "Фильм удален из списка": "Movie removed from",
  "Загрузка постера": "Loading poster",
    "Удалить фильм из списка?": "Remove movie from list?",
    "Удалить": "Delete",
    "Отмена": "Cancel",
    "Сохранить": "Save",
    "Редактировать": "Edit",
    "TMDB": "TMDB",
    "Рейтинг TMDB": "TMDB rating",
    "Сезоны": "Seasons",
    "Сезон": "Season",
    "Всего сезонов": "Total seasons",
    "Оценки сезонов": "Season ratings",
    "Средняя оценка сезонов": "Average season rating",
    "Ось субъективности": "Subjectivity axis",
    "Среднее отклонение": "Average difference",
    "Среднее отклонение от TMDB": "Average difference from TMDB",
    "Средняя абсолютная разница": "Average absolute difference",
    "Фильмов в выборке": "Movies in sample",
    "Краткий вывод по оси субъективности": "Subjectivity axis summary",
    "Оценка TMDB": "TMDB rating",
    "Ваша оценка": "Your rating",
    "Вид дневника": "Diary view",
    "Книга": "Book",
    "Список": "List",
    "Разница с TMDB": "Difference from TMDB",
    "Совпадение с TMDB": "Matches TMDB",
    "Уникальных сочетаний": "unique score pairs",
    "Выше TMDB": "Higher than TMDB",
    "Близко к TMDB": "Close to TMDB",
    "Ниже TMDB": "Lower than TMDB",
    "Сильные расхождения": "Strong differences",
    "Насколько ваши оценки отличаются от рейтинга TMDB.": "How much your ratings differ from TMDB ratings.",
    "Нажмите на категорию, чтобы увидеть фильмы.": "Tap a category to view its movies.",
    "Нажмите на категорию, чтобы открыть список.": "Tap a category to open the list.",
    "Показать список": "Show list",
    "Ваши оценки чаще выше среднего рейтинга TMDB. Ваш вкус немного мягче массового.": "Your ratings are more often above the average TMDB rating. Your taste is a little gentler than the mainstream.",
    "Ваши оценки чаще ниже среднего рейтинга TMDB. Ваш вкус немного строже массового.": "Your ratings are more often below the average TMDB rating. Your taste is a little stricter than the mainstream.",
    "Средняя разница": "Average difference",
    "Фильтр оси субъективности": "Subjectivity axis filter",
    "Вы чаще оцениваете фильмы выше среднего рейтинга TMDB. Ваш вкус немного мягче массового.": "You more often rate films above the average TMDB rating. Your taste is a little gentler than the mainstream.",
    "Вы чаще оцениваете фильмы ниже среднего рейтинга TMDB. Ваш вкус немного строже массового.": "You more often rate films below the average TMDB rating. Your taste is a little stricter than the mainstream.",
    "Ваши оценки в среднем совпадают с рейтингом TMDB. Ваш вкус близок к массовому.": "Your ratings generally match TMDB ratings. Your taste is close to the mainstream.",
    "Фильмов в группе": "Movies in group",
    "оценка пользователя": "user rating",
    "моя": "mine",
    "не оценено": "not rated",
    "просмотрено": "watched",
    "просмотрен": "watched",
    "без оценки": "without rating",
    "минут": "minutes",
    "Загрузка...": "Loading...",
    "Загрузка…": "Loading...",
    "Загрузка страницы...": "Loading page...",
    "Загрузка аутентификации...": "Loading authentication...",
    "Показать ещё": "Show more",
  "Показать все": "Show all",
  "Показать всех": "Show all",
    "Все": "All",
    "Все типы": "All types",
    "Фильмы": "Movies",
    "Сериалы": "Series",
    "Фильмы и сериалы": "Movies and series",
    "Тип контента": "Content type",
    "Количество и время просмотра": "Watch count and time",
    "Просмотрено сезонов": "Seasons watched",
    "Отдельно оценено сезонов": "Seasons rated separately",
    "Сериалов с общей оценкой": "Series with an overall rating",
    "Сезонов с отдельной оценкой": "Seasons rated separately",
    "Эпизодов по детальным данным": "Episodes in detailed viewing data",
    "Общая оценка сериала не содержит данных о количестве просмотренных сезонов. Сезоны и эпизоды показаны только для сериалов с отдельной сезонной или поэпизодной детализацией. Это не среднее и не означает, что у остальных сериалов просмотрено 0 сезонов.": "An overall series rating does not record how many seasons were watched. Season and episode counts are shown only for series with separate season-level or episode-level details. These values are not averages and do not mean that zero seasons were watched for every other series.",
    "нет точных данных": "no exact data",
    "Оценено сериалов": "Series rated",
    "нет данных о просмотренных сезонах": "no watched-season data",
    "не удалось определить длительность эпизодов": "episode runtime unavailable",
    "Только отдельно оценённые сезоны или отмеченные эпизоды": "Only separately rated seasons or marked episodes",
    "Время просмотра фильмов": "Movie watch time",
    "Время просмотра сериалов": "Series watch time",
    "Расчёт времени сериалов": "Series time calculation",
    "Только оценённые сезоны с известным числом эпизодов": "Rated seasons with a known episode count only",
    "Общее время просмотра": "Total watch time",
    "Средняя продолжительность эпизода": "Average episode runtime",
    "Средняя оценка фильмов": "Average movie rating",
    "Средняя оценка сериалов": "Average series rating",
    "Время сериалов показано только для оценённых сезонов с известным числом эпизодов.": "Series time is shown only for rated seasons with a known episode count.",
    "Элементов в группе": "Items in group",
    "Элементов в выборке": "Items in selection",
    "Разница по количеству": "Count difference",
    "Детальные оценки": "Detailed ratings",
    "Нажмите на фильм, чтобы посмотреть его оценки по критериям.": "Tap a movie to view its criterion scores.",
    "Показать критерии": "Show criteria",
    "Скрыть критерии": "Hide criteria",
    "Карта просмотра друга": "Friend's watch map",
    "Распределение по странам на карте": "Country distribution map",
    "Ваша карта просмотра": "Your watch map",
    "Закрыть список": "Close list",
    "В этой категории пока нет данных": "There is no data in this category yet",
    "участники съёмочной группы": "cast and crew",
    "Количество": "Count",
    "с участником.": "featuring this person.",
    "Для этой категории пока нет данных.": "There is no data for this category yet.",
    "по оценкам": "based on ratings",
    "Сериалов": "Series",
    "Самое пересматриваемое": "Most rewatched",
    "Среднее фильмов и сериалов в неделю": "Average movies and series per week",
    "Самый переоценённый фильм или сериал": "Most overrated movie or series",
    "Самый недооценённый фильм или сериал": "Most underrated movie or series",
    "Оценок 10": "Ratings of 10",
    "Оценок 9": "Ratings of 9",
    "Оценок 8": "Ratings of 8",
    "Оценок 7": "Ratings of 7",
    "Оценок 6": "Ratings of 6",
    "Оценок 5": "Ratings of 5",
    "Оценок 4": "Ratings of 4",
    "Оценок 3": "Ratings of 3",
    "Оценок 2": "Ratings of 2",
    "Оценок 1": "Ratings of 1",
    "Персоны": "People",
    "Скрыть уже просмотренные": "Hide watched titles",
    "Сортировка каталога": "Catalogue sorting",
    "Сортировка результатов": "Result sorting",
    "По популярности": "By popularity",
    "По релевантности": "By relevance",
    "По году: сначала новые": "By year: newest first",
    "По году: сначала старые": "By year: oldest first",
    "По оценке TMDB: сначала высокие": "By TMDB rating: highest first",
    "По оценке TMDB: сначала низкие": "By TMDB rating: lowest first",
    "Введите фильм, сериал или имя персоны": "Enter a movie, series or person",
    "Введите название или оставьте пустым": "Enter a title or leave it blank",
    "Найдено:": "Found:",
    "Загрузка результатов...": "Loading results...",
    "Ничего не найдено": "Nothing found",
    "Не оценено": "Not rated",
    "Просмотрен": "Watched",
    "из списка": "from list",
    "Фильм не найден в каталоге": "Movie not found in catalog",
    "Не удалось открыть": "Could not open",
    "Попробуйте ещё раз.": "Please try again.",
    "Войдите, чтобы добавить фильм в список «Буду смотреть».": "Sign in to add the movie to your watchlist.",
    "Не удалось добавить фильм: нет ID фильма.": "Could not add movie: missing movie ID.",
    "Фильм добавлен в список «Буду смотреть».": "Movie added to watchlist.",
    "Не удалось добавить фильм в список.": "Could not add movie to the list.",
    "Жанр": "Genre",
    "Ошибка": "Error",
    "Персона не найдена": "Person not found",
    "Биография не указана": "Biography is not available",
    "Дата рождения": "Date of birth",
    "Место рождения": "Place of birth",
    "Фильмография": "Filmography",
    "Участие": "Credit",
    "Роль": "Role",
    "Не указана": "Not specified",
    "Рейтинг": "Rating",
    "Моя оценка": "My rating",
    "фото": "photo",
    "Фотографии": "Photos",
    "Нет фильмов по выбранным фильтрам.": "No movies match the selected filters.",
    "Участники съёмочной группы": "Cast & Crew",
    "Актёры": "Actors",
    "Актеры": "Actors",
    "Режиссёры": "Directors",
    "Режиссеры": "Directors",
    "Сценаристы": "Writers",
    "Композиторы": "Composers",
    "Художники": "Artists",
    "Монтажёры": "Editors",
    "Монтажеры": "Editors",
    "Фильмы по участникам съёмочной группы": "Movies by cast and crew",
    "Дополняем сохранённую статистику": "Completing saved statistics",
    "Загрузка сохранённой статистики...": "Loading saved statistics...",
    "Для этой категории в сохранённых фильмах пока нет данных.": "No data for this category in saved movies yet.",
    "Просмотрено": "Watched",
    "У вас": "You",
    "Свернуть список": "Collapse list",
    "Загружаем ещё участников...": "Loading more people...",
    "только что": "just now",

    "Возраст:": "Age:",
    "Не указан": "Not specified",
    "Заметка:": "Note:",
    "Напишите о себе": "Write about yourself",
    "Пользователь пока ничего не написал": "The user has not written anything yet",
    "поделиться профилем": "share profile",
    "Обновить карточку для ссылок": "Refresh link card",
    "Обновляем карточку…": "Refreshing link card…",
    "Карточка обновлена": "Link card updated",
    "Карточку можно обновлять не чаще одного раза в 10 минут": "The link card can be refreshed once every 10 minutes",
    "Не удалось обновить карточку. Попробуйте позже.": "Could not refresh the link card. Please try again later.",
    "Серия:": "Streak:",
    "неделя": "week",
    "недели": "weeks",
    "недель": "weeks",

    "Испытания": "Challenges",
  "Карты недели": "Weekly Cards",
  "Перемешиваем карты недели…": "Shuffling weekly cards...",
  "Еженедельные задания": "Weekly quests",
  "Еженедельные карты": "Weekly cards",
  "открыто": "opened",
  "выбрано": "selected",
  "Каждый понедельник выпадает 7 закрытых карт.": "Every Monday, 7 hidden cards drop.",
  "За неделю можно открыть 5 и выбрать 3 задания.": "Each week you can open 5 and choose 3 quests.",
  "Шанс легендарной карты на этой неделе:": "Legendary card chance this week:",
  "Закрытая карта": "Hidden card",
  "Нажмите, чтобы открыть": "Click to open",
  "Фильм-источник:": "Source movie:",
  "Источник критериев": "Criteria source",
  "Выполнено": "Completed",
  "Недоступна": "Unavailable",
    "Загрузка карт недели": "Loading weekly cards",
    "Развернуть карты недели": "Expand weekly cards",
    "Свернуть карты недели": "Collapse weekly cards",
    "Текущая неделя": "Current week",
  "Добавить карту недели": "Add weekly card",
  "Загрузка карт...": "Loading cards...",
  "Карты недели выполнены": "Weekly cards completed",
  "Выбрать карты недели": "Choose weekly cards",
  "Экспедиция": "Expedition",
  "Экспедиция завершена": "Expedition completed",
  "Экспедиция не пройдена": "Expedition not completed",
  "Активная экспедиция": "Active expedition",
  "Открываем недельные экспедиции...": "Opening weekly expeditions...",
  "Соло-экспедиции": "Solo expeditions",
  "Экспедиции недели": "Weekly expeditions",
  "Можно выбрать 1 экспедицию": "You can choose 1 expedition",
  "Общий дедлайн — конец текущей недели": "Overall deadline — end of the current week",
  "Шанс легендарной:": "Legendary chance:",
  "Фильтры экспедиций": "Expedition filters",
  "Правила зачёта экспедиций": "Expedition scoring rules",
  "Правила зачета экспедиций": "Expedition scoring rules",
  "Как засчитывается просмотр": "How a watch counts",
  "Текущий режим — соло-недельная экспедиция: одну экспедицию можно выбрать на неделю.": "Current mode — solo weekly expedition: you can choose one expedition for the week.",
  "Дедлайны фиксированы: этап 1 — вторник 23:59, этап 2 — четверг 23:59, финал — воскресенье 23:59.": "Deadlines are fixed: stage 1 — Tuesday 23:59, stage 2 — Thursday 23:59, final — Sunday 23:59.",
  "Учитывается первое сохранение оценки во время активного этапа и до дедлайна этого этапа.": "The first saved rating during an active stage and before its deadline counts.",
  "Ручную дату просмотра можно поставить за сегодня или вчера; более ранняя дата в прогресс не попадёт.": "A manual watch date can be today or yesterday; earlier dates do not count.",
  "Ручную дату просмотра можно поставить за сегодня или вчера; более ранняя дата в прогресс не попадет.": "A manual watch date can be today or yesterday; earlier dates do not count.",
  "После завершения этапа изменение оценки или даты не отменяет зачёт.": "After a stage is completed, changing the rating or date does not cancel the result.",
  "После завершения этапа изменение оценки или даты не отменяет зачет.": "After a stage is completed, changing the rating or date does not cancel the result.",
  "Удаление зачтённой оценки отзывает результат, и экспедиция считается не пройденной.": "Deleting a counted rating revokes the result, and the expedition is considered not completed.",
  "Удаление зачтенной оценки отзывает результат, и экспедиция считается не пройденной.": "Deleting a counted rating revokes the result, and the expedition is considered not completed.",
  "Выбирать экспедиции можно только в своём профиле.": "Expeditions can only be chosen from your own profile.",
  "Выбирать экспедиции можно только в своем профиле.": "Expeditions can only be chosen from your own profile.",
  "У недельных соло-экспедиций фиксированные сроки. Первый этап нужно завершить до вторника, 23:59, поэтому со среды выбрать и пройти испытания этой недели уже не получится. Новые экспедиции будут доступны в понедельник.": "Solo weekly expeditions have fixed deadlines. The first stage must be completed by Tuesday at 23:59, so from Wednesday it is no longer possible to choose and complete this week's challenges. New expeditions will be available on Monday.",
  "Не пройдена: время истекло": "Not completed: time expired",
  "На этой неделе уже выбрана другая экспедиция": "Another expedition is already selected this week",
  "Выбрать экспедицию": "Choose expedition",
  "Экспедиция начинается": "Expedition begins",
  "Добро пожаловать.": "Welcome.",
  "Первый этап уже ждёт вас.": "The first stage is already waiting for you.",
  "Первый этап уже ждет вас.": "The first stage is already waiting for you.",
  "Загрузка экспедиции": "Loading expedition",
  "Загрузка экспедиции...": "Loading expedition...",
  "не выбрана": "not selected",
  "Развернуть экспедицию": "Expand expedition",
  "Свернуть экспедицию": "Collapse expedition",
  "Не пройдена": "Not completed",
    "Активна": "Active",
    "Завершена": "Completed",
    "Время истекло — экспедиция не пройдена.": "Time expired — expedition failed.",
    "Время истекло — экспедиция не пройдена": "Time expired — expedition failed",
    "Выбрать": "Choose",
    "Выбрана": "Selected",
    "Этап 1": "Stage 1",
    "Этап 2": "Stage 2",
    "Финал": "Final",

    "Персональные": "Personal",
    "Подборки для вас": "For You",
    "Тематические": "Thematic",
    "персонально": "personal",
    "Рекомендации для меня": "Recommendations for me",
    "Подборка по конкретным совпадениям с вашими оценками 8–10.": "A selection based on matches with your 8–10 ratings.",
    "Сравниваем кандидатов с фильмами, которым вы поставили 8–10.": "Comparing candidates with movies you rated 8–10.",
    "Оцените хотя бы 3 фильма на 8–10, и здесь появится персональная подборка.": "Rate at least 3 movies 8–10 and a personal selection will appear here.",
    "Подходящих непросмотренных фильмов пока не нашлось.": "No suitable unwatched movies found yet.",
    "Собираем рекомендации...": "Collecting recommendations...",
    "Не удалось обновить рекомендации. Попробуйте позже.": "Could not refresh recommendations. Please try again later.",
    "Обновить": "Refresh",
    "Обновить рекомендации": "Refresh recommendations",
  "обновлено": "updated",
  "Почему рекомендуем": "Why we recommend it",
  "Скрыть рекомендацию": "Hide recommendation",
  "Разделы рекомендаций": "Recommendation sections",
    "жанры уточняются": "genres pending",
    "Жанр загружается": "Loading genre",
    "Не по жанрам, а по ощущению, устройству истории и способу съёмки.": "Not by genre, but by mood, story structure and filmmaking style.",

    "Оценки друзей": "Friends' ratings",
    "Загружаем оценки…": "Loading ratings...",
    "Не удалось загрузить оценки друзей.": "Could not load friends' ratings.",
    "Не удалось сохранить оценку из-за несовместимых прав доступа. Обновите страницу и повторите попытку.": "The rating could not be saved because access permissions are incompatible. Refresh the page and try again.",
    "Не удалось сохранить оценку. Повторите попытку.": "The rating could not be saved. Please try again.",
    "Не удалось сохранить детальную оценку. Повторите попытку.": "The detailed rating could not be saved. Please try again.",
    "Не удалось удалить оценку. Повторите попытку.": "The rating could not be deleted. Please try again.",
    "Добавьте друзей, чтобы видеть их оценки.": "Add friends to see their ratings.",
    "Друзья пока не отметили этот фильм.": "Friends have not marked this movie yet.",
    "Средняя оценка друзей": "Average friends' rating",
    "Оценили:": "Rated:",
    "Оценено": "Rated",

    "Возможно вам будут интересны": "You might also like",
    "Сиквелы": "Sequels",
    "Перезаписать оценку?": "Overwrite rating?",
    "Вы уже выставили детальную или по-сезонную оценку. Вы уверены, что хотите изменить её?": "You already have a detailed or season rating. Are you sure you want to change it?",
    "Удалить оценку?": "Delete rating?",
    "Оценка с датой просмотра": "Rating with watch date",
    "Дата просмотра": "Watch date",
    "Предыдущий год": "Previous year",
    "Предыдущий месяц": "Previous month",
    "Следующий месяц": "Next month",
    "Следующий год": "Next year",
    "Сохранить просмотр с датой": "Save watched date",
    "Сохранить оценку с датой": "Save rating with date",
    "Оценить детально с датой": "Rate in detail with date",

    "Личная статистика": "Personal statistics",
    "Сводка просмотров, оценок, игровой активности и динамики за выбранный период.": "A summary of views, ratings, game activity and trends for the selected period.",
    "Выбор периода": "Period selector",
    "Месяц": "Month",
    "Год": "Year",
    "Предыдущий период": "Previous period",
    "Следующий период": "Next period",
    "Месяц итогов": "Results month",
    "Год итогов": "Results year",
    "Краткие итоги": "Quick summary",
    "Фильмов": "Movies",
    "Часов": "Hours",
    "Стран": "Countries",
    "Опыта": "Experience",
    "Собираю итоги...": "Collecting results...",
    "За этот период пока нет данных.": "No data for this period yet.",
    "Общая активность": "Overall activity",
    "Просмотрено фильмов": "Movies watched",
    "Просмотрено сериалов": "Series watched",
    "Просмотрено эпизодов": "Episodes watched",
    "Новых фильмов": "New movies",
    "Пересмотров": "Rewatches",
    "Часов просмотра": "Hours watched",
    "Средняя продолжительность фильма": "Average movie length",
    "Самый длинный фильм": "Longest movie",
    "Самый короткий фильм": "Shortest movie",
    "Среднее фильмов в неделю": "Average movies per week",
    "Самый продуктивный день": "Most productive day",
    "Самый продуктивный месяц": "Most productive month",
    "Оценки": "Ratings",
    "Средняя оценка года": "Average rating this year",
    "Средняя оценка месяца": "Average rating this month",
    "Самая высокая оценка": "Highest rating",
    "Самая низкая оценка": "Lowest rating",
    "Самая частая оценка": "Most frequent rating",
    "Самый переоценённый фильм": "Most overrated movie",
    "Самый переоцененный фильм": "Most overrated movie",
    "Самый недооценённый фильм": "Most underrated movie",
    "Самый недооцененный фильм": "Most underrated movie",
    "Среднее отличие от TMDB": "Average difference from TMDB",
    "Изменений оценки": "Rating changes",
    "География": "Geography",
    "Новых стран открыто": "New countries discovered",
    "Лучшая средняя оценка по странам": "Best average rating by country",
    "Больше всего просмотрено из страны": "Most watched country",
    "Всего стран просмотрено": "Total countries watched",
    "Жанры": "Genres",
    "Самый просматриваемый жанр": "Most watched genre",
    "Самая высокая средняя оценка": "Highest average rating",
    "Новый открытый жанр": "New genre discovered",
    "Самый редкий жанр": "Rarest genre",
    "Больше всего вырос": "Biggest growth",
    "По годам": "By year",
    "Самый старый фильм": "Oldest movie",
    "Самый новый фильм": "Newest movie",
    "Люди": "People",
    "Новый режиссёр": "New director",
    "Новый режиссер": "New director",
    "Новый актёр": "New actor",
    "Новый актер": "New actor",
    "Режиссёр, который встречался чаще всего": "Most frequent director",
    "Режиссер, который встречался чаще всего": "Most frequent director",
    "Актёр, который встречался чаще всего": "Most frequent actor",
    "Актер, который встречался чаще всего": "Most frequent actor",
    "Самый высоко оценённый режиссёр": "Highest-rated director",
    "Самый высоко оцененный режиссер": "Highest-rated director",
    "Самый высоко оценённый актёр": "Highest-rated actor",
    "Самый высоко оцененный актер": "Highest-rated actor",
    "Игровая часть": "Game progress",
    "Получено уровней": "Levels gained",
    "Получено опыта": "Experience gained",
    "Получено достижений": "Achievements earned",
    "Выполнено испытаний": "Challenges completed",
    "Выполнено карт недели": "Weekly cards completed",
    "Выполнено легендарных карт": "Legendary cards completed",
    "Самая длинная серия месяца": "Longest monthly streak",
    "Качество недель": "Week quality",
    "Качество недели": "Week quality",
    "Самая редкая карта": "Rarest card",
    "Социальное": "Social",
    "Написано рецензий": "Reviews written",
    "Добавлено друзей": "Friends added",
    "Выполнение целей": "Goal completion",
    "Выполнено недель": "Weeks completed",
    "Закрыто серебряных недель": "Silver weeks closed",
    "Закрыто золотых недель": "Gold weeks closed",
    "Закрыто легендарных недель": "Legendary weeks closed",
    "Процент выполненных карт": "Card completion percent",
    "Самая длинная цепочка карт": "Longest card chain",
    "Динамика к прошлому году": "Change vs previous year",
    "Динамика к прошлому месяцу": "Change vs previous month",
    "Жанров": "Genres",
    "Режиссёров": "Directors",
    "Режиссеров": "Directors",
    "Актёров": "Actors",
    "Актеров": "Actors",
    "Уровней": "Levels",
    "Друзей": "Friends",
    "Интересные факты": "Interesting facts",
    "Больше всего смотрели": "Most watched on",
    "Самый длинный перерыв": "Longest break",
    "Самый длинный марафон": "Longest marathon",
    "легендарная": "legendary",
    "эпическая": "epic",
    "редкая": "rare",
    "обычная": "common",
    "воскресеньям": "Sundays",
    "понедельникам": "Mondays",
    "вторникам": "Tuesdays",
    "средам": "Wednesdays",
    "четвергам": "Thursdays",
    "пятницам": "Fridays",
    "субботам": "Saturdays",

    "Рецензии": "Reviews",
    "рецензия": "review",
    "рецензий": "reviews",
    "Написать рецензию": "Write a review",
    "Изменить мою рецензию": "Edit my review",
    "Положительная": "Positive",
    "Нейтральная": "Neutral",
    "Отрицательная": "Negative",

    "Паспорт киномана": "Movie Passport",
    "Уровень": "Level",
    "Опыт": "Experience",
    "Средняя оценка": "Average rating",
    "Средняя": "Average",
    "Текущая серия": "Current streak",
    "Лучшая серия": "Best streak",
    "На сайте": "On site",
    "Частый жанр": "Top genre",
    "Частая страна": "Top country",
    "Частое десятилетие": "Top decade",
    "Распределение по оценкам": "Rating distribution",
    "Распределение по странам": "Country distribution",
    "Шкала графика": "Chart scale",
    "Линейная": "Linear",
    "Логарифмическая": "Logarithmic",
    "Увеличивает мелкие значения, сохраняя реальные числа": "Enlarges small values while preserving the real numbers",
    "Детальная оценка фильмов": "Detailed movie ratings",
    "Все оценки": "All ratings",
    "Минимальная оценка": "Minimum rating",
    "Максимальная оценка": "Maximum rating",
    "Все 9-ки": "All 9s",
    "Все 8-ки": "All 8s",
    "Все 7-ки": "All 7s",
    "Все 6-ки": "All 6s",
    "Все 5-ки": "All 5s",
    "Все 4-ки": "All 4s",
    "Все 3-ки": "All 3s",
    "Все 2-ки": "All 2s",
    "Все 1-ки": "All 1s",
    "От 8 до 10": "From 8 to 10",
    "От 5 до 7": "From 5 to 7",
    "До 5": "Below 5",
    "Сначала высокие оценки": "Highest ratings first",
    "Сначала низкие оценки": "Lowest ratings first",
    "Оценок по выбранному фильтру нет.": "No ratings match the selected filter.",
    "Выйти из аккаунта?": "Sign out?",
    "Вы действительно хотите выйти из аккаунта?": "Are you sure you want to sign out?",
    "Выйти": "Sign out",
    "Выходим…": "Signing out…",
    "Распределение по жанрам": "Genre distribution",
    "Распределение по годам": "Year distribution",
    "Распределение по десятилетиям": "Decade distribution",
    "Карта просмотренных фильмов друга": "Friend's watched movies map",
    "Распределение просмотренных фильмов по странам на карте": "Watched movies by country map",
    "Ваша карта просмотренных фильмов": "Your watched movies map",
    "Просм.": "Watched",

    "Введите имя, почту или UID": "Enter name, email or UID",
    "Ваши друзья": "Your friends",
    "Друзья пользователя": "User's friends",
    "Возраст": "Age",
    "Ур.": "Lvl.",
    "Данные недоступны": "Data unavailable",
  "Загрузка данных...": "Loading data...",
  "Загрузка профиля...": "Loading profile...",
  "Пользователи не найдены": "No users found",
  "Удалить из друзей": "Remove from friends",
    "Удалить из друзей?": "Remove friend?",

    "Мои любимые фильмы": "My Favorite Movies",
    "Без названия": "Untitled",
    "Страна": "Country",
    "Страна:": "Country:",

    "Сложность": "Difficulty",
    "Тип": "Type",
    "Активные": "Active",
  "Легкие": "Easy",
  "Лёгкие": "Easy",
  "Средние": "Medium",
    "Нормальные": "Normal",
    "Сложные": "Hard",
    "Очень сложные": "Very hard",
    "Невозможные": "Impossible",
    "Активность": "Activity",
    "Страны": "Countries",
    "Десятилетия": "Decades",
    "Годы": "Years",
    "Хронометраж": "Runtime",
    "Формат": "Format",
    "Языки": "Languages",
    "Смешанные": "Mixed",
    "Экспердиции": "Expeditions",
    "Экспедиции": "Expeditions",
    "Запустите испытание и успейте выполнить его до окончания срока.": "Start a challenge and complete it before it expires.",
    "активных": "active",
    "Испытание завершено": "Challenge completed",
    "Первый шаг": "First step",
    "Двойной сеанс": "Double feature",
    "Жанровая проба": "Genre sample",
    "Прыжок во времени": "Time jump",
    "Новое лицо": "New face",
    "Разогрев выходного дня": "Weekend warm-up",
    "Штамп Европы": "Stamp of Europe",
    "Кинопочта мира": "World cine-mail",
    "Финальный этап открыт": "Final stage opened",
    "Финальный этап завершён": "Final stage completed",
    "Финальный этап завершен": "Final stage completed",
    "Этап экспедиции откатан": "Expedition stage rolled back",
    "Обычная": "Common",
    "Редкая": "Rare",
    "Эпическая": "Epic",
    "Легендарная": "Legendary",
    "Посмотреть 1 фильм": "Watch 1 movie",
    "Посмотреть 2 фильма": "Watch 2 movies",
    "Открыть 1 страну": "Discover 1 country",
    "Посмотреть 2 разных жанра": "Watch 2 different genres",
    "Посмотреть кино из 2 разных десятилетий": "Watch movies from 2 different decades",
    "Посмотреть 2 фильма с одним актёром": "Watch 2 movies with one actor",
    "Посмотреть 2 фильма с одним актером": "Watch 2 movies with one actor",

    "Начинающий": "Beginner",
    "Любитель": "Enthusiast",
    "Перфекционист": "Perfectionist",
    "Мировой киноман": "World cinephile",
    "Временной путешественник": "Time traveler",
    "Киноман": "Movie fan",
    "Знаток": "Connoisseur",
    "Активный зритель": "Active viewer",
    "Спринт": "Sprint",
    "Недельный марафон": "Weekly marathon",
    "Жанровый гурман": "Genre gourmet",
    "Знаток режиссеров": "Director expert",
    "Знаток режиссёров": "Director expert",
    "Начинающая серия": "Starting streak",
    "Ежедневный зритель": "Daily viewer",
    "Недельный марафонец": "Weekly marathoner",
    "Критик": "Critic",
    "Мастер": "Master",
    "Эксперт": "Expert",
    "Легенда": "Legend",
    "Супер активный": "Super active",
    "Жанровый коллекционер": "Genre collector",
    "Глобальный зритель": "Global viewer",
    "Режиссерский гурман": "Director gourmet",
    "Режиссёрский гурман": "Director gourmet",
    "Хронолог": "Chronologist",
    "Пять недель подряд": "Five weeks in a row",
    "Мастер серии": "Streak master",
    "Пятнадцать недель подряд": "Fifteen weeks in a row",
    "Месячный чемпион": "Monthly champion",
    "Легенда кино": "Cinema legend",
    "Хронокино 130": "Chronocinema 130",
    "Мировой охват": "World coverage",
    "Год кино": "Year of cinema",
    "Оценили первый фильм": "Rated your first movie",
    "Оценили 10 фильмов": "Rated 10 movies",
    "Оценили 25 фильмов": "Rated 25 movies",
    "10 оценок 10/10": "10 ratings of 10/10",
    "Оценили фильмы из 5 разных стран": "Rated movies from 5 different countries",
    "Оценили фильмы из 5 разных десятилетий": "Rated movies from 5 different decades",
    "Оценили 50 фильмов": "Rated 50 movies",
    "Оценили 75 фильмов": "Rated 75 movies",
    "Оценили 10 фильмов за последний месяц": "Rated 10 movies in the last month",
    "Оценили 10 фильмов за любые 30 дней": "Rated 10 movies within any 30 days",
    "3 фильма за 3 дня": "3 movies in 3 days",
    "5 фильмов за неделю": "5 movies in a week",
    "Оценили фильмы из 10 разных жанров": "Rated movies from 10 different genres",
    "Оценили фильмы 10 разных режиссеров": "Rated movies by 10 different directors",
    "Оценили фильмы 10 разных режиссёров": "Rated movies by 10 different directors",
    "2 недели подряд с просмотрами": "2 consecutive weeks with views",
    "7 дней подряд с просмотрами": "7 consecutive days with views",
    "14 дней подряд с просмотрами": "14 consecutive days with views",
    "Оценили 100 фильмов": "Rated 100 movies",
    "Оценили 200 фильмов": "Rated 200 movies",
    "Оценили 500 фильмов": "Rated 500 movies",
    "Оценили 1000 фильмов": "Rated 1000 movies",
    "20 фильмов за последний месяц": "20 movies in the last month",
    "20 фильмов за любые 30 дней": "20 movies within any 30 days",
    "Оценили фильмы из 20 разных жанров": "Rated movies from 20 different genres",
    "Оценили фильмы из 10 разных стран": "Rated movies from 10 different countries",
    "Оценили фильмы 20 разных режиссеров": "Rated movies by 20 different directors",
    "Оценили фильмы 20 разных режиссёров": "Rated movies by 20 different directors",
    "Оценили фильмы из 10 разных десятилетий": "Rated movies from 10 different decades",
    "5 недель подряд с хотя бы одним просмотром": "5 weeks in a row with at least one view",
    "10 недель подряд с просмотрами": "10 consecutive weeks with views",
    "15 недель подряд с просмотрами": "15 consecutive weeks with views",
    "30 дней подряд с просмотрами": "30 consecutive days with views",
    "Оценили 5000 фильмов": "Rated 5000 movies",
    "1 фильм на каждый год с 1895 по 2025": "1 movie for each year from 1895 to 2025",
    "193 страны — по 1 фильму с каждой": "193 countries — 1 movie from each",
    "365 фильмов за 365 дней": "365 movies in 365 days",

  "История вашей киноманской жизни": "The story of your cinephile life",
  "История киноманской жизни пользователя": "The story of this user's cinephile life",
  "Открываем дневник…": "Opening diary...",
  "Первая глава ещё не написана": "The first chapter has not been written yet",
  "Первая глава еще не написана": "The first chapter has not been written yet",
  "Здесь появятся просмотренные фильмы, достижения, уровни, испытания и новые друзья.": "Watched movies, achievements, levels, challenges and new friends will appear here.",
  "Событие": "Event",
  "Загружаем журнал…": "Loading log...",
  "Здесь пока нет событий.": "No events here yet.",
  "Стереть запись": "Erase entry",
    "Страницы дневника": "Diary pages",
    "Номер страницы дневника": "Diary page number",
  "Перейти в начало дневника": "Go to the first diary page",
  "Предыдущая страница дневника": "Previous diary page",
  "Следующая страница дневника": "Next diary page",
  "Перейти в конец дневника": "Go to the last diary page",
  "Получено достижение": "Achievement earned",
  "Получено достижение «": "Achievement earned: “",
  "Новое достижение разблокировано": "New achievement unlocked",
  "Достижение разблокировано": "Achievement unlocked",
  "Новая глава киноманской истории": "New chapter of your cinephile story",
  "Новая рецензия": "New review",
  "Добавлено в избранное": "Added to favorites",
  "Добавлено в «Буду смотреть»": "Added to “Watchlist”",
  "Новый друг": "New friend",
  "Выполнена карта": "Weekly card completed",
  "Выполнена карта «": "Weekly card completed: “",
  "Выполнено испытание": "Challenge completed",
  "Выполнено испытание «": "Challenge completed: “",
  "Просмотрен фильм": "Movie watched",
  "Просмотрен фильм «": "Movie watched: “",
  "Изменена оценка «": "Rating changed: “",
  "Удалена оценка «": "Rating deleted: “",
  "Написана рецензия «": "Review written: “",
  "»": "”",
  "Оценка": "Rating",
  "За оценку фильма «": "For rating “",
  "За просмотр фильма «": "For watching “",
  "За удаление оценки фильма «": "For deleting the rating for “",
    "опыта": "XP",
    "Этап экспедиции завершён": "Expedition stage completed",
    "Этап экспедиции завершен": "Expedition stage completed",
    "Экспедиция выбрана": "Expedition selected",
    "Экспедиция отозвана": "Expedition revoked",
    "Экспедиция восстановлена": "Expedition restored",
    "Этап экспедиции восстановлен": "Expedition stage restored",
    "Доступна эпическая экспедиция": "Epic expedition available",
    "Доступна легендарная экспедиция": "Legendary expedition available",

    "Уведомления": "Notifications",
  "События, которые вы могли пропустить": "Events you may have missed",
  "Публичные события этого пользователя": "This user's public events",
  "Событие удалено": "Event deleted",
  "Не удалось удалить событие": "Could not delete event",
  "События очищены": "Events cleared",
  "Дневник очищен": "Diary cleared",
  "Не удалось очистить дневник": "Could not clear the diary",
  "Очистить весь дневник": "Clear diary",
  "Очистить весь дневник?": "Clear the entire diary?",
  "Все записи дневника будут удалены. Это действие нельзя отменить.": "All diary entries will be deleted. This action cannot be undone.",
  "Не удалось очистить события": "Could not clear events",
  "Очистить все": "Clear all",
    "Все события": "All events",
    "Ваш прогресс": "Your progress",
    "Просмотрел фильм": "Watched a movie",
    "Получил уровень": "Leveled up",
    "Получил достижение": "Earned achievement",
    "Завершил испытание": "Completed challenge",
    "Запрос в друзья": "Friend request",
    "Получена подборка": "Collection received",
    "Лайк рецензии": "Review like",
    "Комментарий рецензии": "Review comment",
    "Оценил фильм": "Rated a movie",
    "Написал рецензию": "Wrote a review",
    "Серии": "Streaks",
    "Удалить событие": "Delete event",
    "Страницы событий": "Event pages",
    "Нет событий по выбранным фильтрам.": "No events match the selected filters.",
    "Номер страницы событий": "Event page number",
    "Перейти в начало событий": "Go to the first event page",
    "Предыдущая страница событий": "Previous event page",
    "Следующая страница событий": "Next event page",
    "Перейти в конец событий": "Go to the last event page",
    "Очистить все события?": "Clear all events?",
    "Все события в этом разделе будут удалены. Это действие нельзя отменить.": "All events in this section will be deleted. This action cannot be undone.",
    "Очищаем...": "Clearing...",
    "Очистить": "Clear",

    "Оценить детально": "Rate in detail",
    "Оценить с датой просмотра": "Rate with watch date",
    "Отметить просмотренным": "Mark as watched",
    "Личная заметка": "Personal note",
    "Добавить": "Add",
    "в буду смотреть": "to watchlist",

    "The Movie Database (TMDB)": "The Movie Database (TMDB)",
    "Информация о фильмах, сериалах, актёрах, изображениях и часть метаданных предоставлены TMDB.": "Movie, series, cast, image and metadata information is provided by TMDB.",
    "Перейти на сайт TMDB": "Open TMDB"
  }
};

Object.assign(UI_TRANSLATIONS.en, {
  "Подтвердить": "Confirm",
  "Подтвердите действие": "Confirm action",
  "Подтверждённая награда восстановлена из журнала прогресса": "Confirmed reward restored from the progress ledger",
  "Награда за качество недели отозвана": "Weekly quality reward revoked",
  "Награда за недельную серию отозвана": "Weekly streak reward revoked",
  "После пересчёта серверного журнала оценок": "After recalculating the server rating ledger",
  "Оценки ещё синхронизируются. Повторите импорт через несколько секунд.": "Ratings are still syncing. Try the import again in a few seconds.",
  "Профиль опыта ещё синхронизируется. Повторите импорт через несколько секунд.": "The XP profile is still syncing. Try the import again in a few seconds.",
  "Предыдущий расчёт опыта ещё завершается. Повторите импорт через несколько секунд.": "The previous XP calculation is still finishing. Try the import again in a few seconds.",
  "Оценки изменились в другой вкладке. Дождитесь синхронизации и повторите импорт.": "Ratings changed in another tab. Wait for syncing to finish and try the import again.",
  "карта недели": "weekly card",
  "Награда за карту недели": "Weekly card reward",
  "Награда экспедиции отозвана": "Expedition reward revoked",
  "Награда за экспедицию": "Expedition reward",
  "После изменения истории оценок": "After the rating history changed",
  "Точная корректировка результата операции": "Exact adjustment of the operation result",
  "Фактическое изменение опыта с учётом нижней границы 0": "Actual XP change with a lower bound of 0",
  "Награда за активную неделю": "Active week reward",
  "Корректировка награды за недельную серию": "Weekly streak reward adjustment",
  "Кинособытия": "Movie events",
  "Новости друзей": "Friends' news",
  "Лента ожила": "The feed came alive",
  "Новая веха": "New milestone",
  "Отлично": "Great",
  "НОВЫЙ УРОВЕНЬ!": "NEW LEVEL!",
  "опыта получено": "XP earned",
  "Нажмите в любом месте, чтобы закрыть": "Click anywhere to close",
  "Вы добавляете много фильмов подряд.": "You are adding many movies in a row.",
  "Выберите, как учитывать сегодняшние оценки в прогрессе.": "Choose how today's ratings should count toward progress.",
  "Режим на сегодня:": "Mode for today:",
  "Перенос старых оценок": "Importing old ratings",
  "Я реально смотрю эти фильмы сейчас": "I am actually watching these movies now",
  "Выбор сохранится до конца дня. Перенос не влияет на серии и недельные бонусы.": "This choice will be saved until the end of the day. Imports do not affect streaks or weekly bonuses.",
  "Введите число от 0 до 10": "Enter a number from 0 to 10",
  "Оценка фильма": "Movie rating",
  "Сохранить оценку": "Save rating",
  "Отменить ввод оценки": "Cancel rating input",
  "Ввести оценку с клавиатуры": "Enter rating with keyboard",
  "Проведите пальцем по иконкам оценок, чтобы выбрать значение.": "Swipe across the rating icons to choose a value.",
  "Оценить по сезонам": "Rate by seasons",
  "Выберите сезон, чтобы оценить его отдельно или перейти к эпизодам": "Choose a season to rate it separately or open its episodes",
  "Все сезоны": "All seasons",
  "Моя оценка сезона": "My season rating",
  "Моя оценка сериала": "My series rating",
  "Удалить оценку сезона": "Delete season rating",
  "Сохранить оценки сезонов": "Save season ratings",
  "Не удалось сохранить оценки сезонов. Повторите попытку.": "Could not save season ratings. Try again.",
  "Эпизоды": "Episodes",
  "Оценки эпизодов": "Episode ratings",
  "Эпизод": "Episode",
  "Оценить": "Rate",
  "Средняя оценка эпизодов": "Average episode rating",
  "Оценено эпизодов": "Rated episodes",
  "оценено": "rated",
  "Лучший эпизод": "Best episode",
  "Худший эпизод": "Worst episode",
  "Статистика сезона": "Season statistics",
  "График оценок эпизодов": "Episode ratings chart",
  "Оценки по эпизодам": "Ratings by episode",
  "Страницы графика эпизодов": "Episode chart pages",
  "Предыдущие эпизоды": "Previous episodes",
  "Следующие эпизоды": "Next episodes",
  "Показать следующие эпизоды": "Show next episodes",
  "осталось": "remaining",
  "Действия с просмотром эпизода": "Episode viewing actions",
  "Текущая оценка эпизода": "Current episode rating",
  "Оценка эпизода и его история просмотров сохраняются независимо.": "The episode rating and its viewing history are saved independently.",
  "История просмотров эпизода": "Episode viewing history",
  "Дата и пересмотры эпизода": "Episode date and rewatches",
  "Просмотров эпизодов": "Episode viewings",
  "Повторных просмотров эпизодов": "Episode rewatches",
  "Повторных просмотров сезонов": "Season rewatches",
  "повторных просмотров": "rewatches",
  "просмотров сезона": "season viewings",
  "Просмотров сезона": "Season viewings",
  "Просмотров с известной датой": "Viewings with a known date",
  "Последний просмотр эпизода": "Latest episode viewing",
  "Просмотров": "Viewings",
  "В истории эпизода пока нет записей. Оценка сохранена отдельно.": "This episode has no viewing-history entries yet. Its rating is stored separately.",
  "оценок эпизодов — график появится после трёх": "episode ratings — the chart appears after three",
  "Не удалось загрузить эпизоды сезона": "Could not load season episodes",
  "Не удалось загрузить оценки эпизодов": "Could not load episode ratings",
  "Не удалось сохранить оценку эпизода. Повторите попытку.": "Could not save the episode rating. Try again.",
  "Удалить оценку эпизода": "Delete episode rating",
  "Удалить оценку эпизода?": "Delete the episode rating?",
  "Удалить оценку и историю эпизода": "Delete episode rating and history",
  "Да, удалить": "Yes, delete",
  "Вы пересмотрели этот эпизод": "You watched this episode",
  "Вы посмотрели этот эпизод": "You watched this episode",
  "раз. Удалить оценку эпизода и всю историю его просмотров? Если нужно удалить только отдельные пересмотры, откройте историю пересмотров и удалите нужные записи там.": "times. Delete its rating and the entire viewing history? To remove only specific rewatches, open the rewatch history and delete the required entries there.",
  "Оценивание откроется после выхода эпизода": "Rating will become available after the episode is released",
  "Ещё не вышел": "Not released yet",
  "В сезоне пока нет эпизодов": "This season has no episodes yet",
  "В этом сезоне пока нет оценок эпизодов": "This season has no episode ratings yet",
  "Выберите сериал, затем сезон, чтобы посмотреть оценки эпизодов и график.": "Choose a series, then a season to see its episode ratings and chart.",
  "Выберите сериал, затем сезон, чтобы сравнить самостоятельную оценку сезона с оценками эпизодов.": "Choose a series, then a season to compare its independent season rating with its episode ratings.",
  "Показать все сезоны": "Show all seasons",
  "Свернуть сезоны": "Collapse seasons",
  "Сериал без названия": "Untitled series",
  "Здесь появятся оценки эпизодов после их сохранения.": "Episode ratings will appear here after you save them.",
  "Здесь появятся оценки сезонов и эпизодов после их сохранения.": "Season and episode ratings will appear here after you save them.",
  "Спецэпизоды": "Specials",
  "Удалить детальную оценку": "Delete detailed rating",
  "Не удалось удалить детальную оценку. Повторите попытку.": "Could not delete the detailed rating. Try again.",
  "Простая оценка": "Simple rating",
  "Средняя детальная оценка": "Detailed rating average",
  "Простая и детальная оценки сохраняются независимо.": "Simple and detailed ratings are saved independently.",
  "Будет удалена только простая оценка": "Only the simple rating will be deleted for",
  "Детальная оценка, оценки сезонов и эпизодов сохранятся.": "The detailed rating, season ratings, and episode ratings will remain.",
  "Детальная оценка удалена": "Detailed rating deleted",
  "Оценки сезонов обновлены": "Season ratings updated",
  "Синхронизация…": "Syncing…",
  "Карты недели ещё загружаются": "Weekly cards are still loading",
  "Сериалов с эпизодными оценками": "Series with episode ratings",
  "Сериалы с эпизодными оценками": "Series with episode ratings",
  "Сериалы с оценками сезонов и эпизодов": "Series with season and episode ratings",
  "Оценки сезонов и эпизодов": "Season and episode ratings",
  "Оценено сезонов": "Rated seasons",
  "эпизодов": "episodes",
  "Моя": "Mine",
  "Она хранится отдельно и не пересчитывается из оценок эпизодов.": "It is stored separately and is not recalculated from episode ratings.",
  "Средняя оценка эпизода": "Average episode rating",
  "Эпизодные оценки считаются отдельно и не входят в количество оценок фильмов и сериалов.": "Episode ratings are counted separately and do not increase movie or series rating totals.",
  "Просмотрено без оценки": "Watched without rating",
  "Удалить оценку": "Delete rating",
  "Детальное оценивание фильма": "Detailed movie rating",
  "Сохранить оценки": "Save ratings",
  "Связность сцен и использование переходов и соответствие времени/месту действия": "Scene cohesion, transitions and time/place consistency",
  "Поставить оценку": "Set rating",
  "мин": "min",
  "ч": "h",
  "Астрид и Рафазэлла": "Astrid and Raphaelle",
  "Воспоминания о будущем": "Memories of the Future",
  "Вход в никуда": "Entrance to Nowhere",
  "За гранью: Я буду рядом. Будущее": "Beyond the Edge: I Will Be Near. The Future",
  "Легенда о пианисте": "The Legend of 1900",
  "NAVI. Рожденные побеждать": "NAVI. Born to Win",
  "NAVI. Рождённые побеждать": "NAVI. Born to Win",
  "Одна": "The One",
  "Осенняя мелодия": "Autumn Melody",
  "Очень страшное кино": "Scary Movie",
  "Посредник": "The Mediator",
  "Подельники": "Accomplices",
  "Рожденные побеждать": "Born to Win",
  "Рождённые побеждать": "Born to Win",
  "Сплит. Звезда на грани": "Split: Star on the Edge",
  "Сумрак": "Twilight",
  "Хоттабыч": "Hottabych",
  "Хрустальный цветок в увядающем мире": "Garakowa: Restore the World",

  "Закрыть приветствие": "Close welcome",
  "Добро пожаловать": "Welcome",
  "Начнем? Можно перенести ваши старые оценки и списки из таблицы и сразу собрать личную историю просмотров.": "Ready to begin? You can import your old ratings and lists from a table and immediately build your personal viewing history.",
  "Импортировать оценки и списки": "Import ratings and lists",
  "Пока пропустить": "Skip for now",
  "Здесь будет жить вся ваша история как киномана.": "Your whole cinephile history will live here.",
  "Соберите уникальный кинопаспорт, который отражает ваши вкусы и привычки.": "Build a unique movie passport that reflects your taste and habits.",
  "Открывайте фильмы со всего мира и собирайте собственную карту кино.": "Discover movies from around the world and build your own cinema map.",
  "Узнайте, какие жанры вы любите больше всего и чем отличаетесь от друзей.": "See which genres you love most and how you differ from friends.",
  "Получайте достижения за просмотр фильмов и исследование мира кино.": "Earn achievements for watching movies and exploring cinema.",
  "Испытания превратят просмотр фильмов в настоящее приключение.": "Challenges turn movie watching into a real adventure.",
  "Находите фильмы по атмосфере, эмоциям и необычным темам, а не только по жанрам.": "Find movies by atmosphere, emotion and unusual themes — not just by genre.",
  "Каждый просмотр становится новой страницей вашей киноманской жизни.": "Every watch becomes a new page of your cinephile life.",
  "Теперь начните создавать собственную историю киномана.": "Now start creating your own cinephile story.",
  "Назад": "Back",
  "Дальше": "Next",
  "начать": "start",

  "Смена пароля": "Change password",
  "Вход и регистрация": "Sign in and sign up",
  "Введите email аккаунта. Мы отправим ссылку, по которой можно задать новый пароль.": "Enter your account email. We will send a link to set a new password.",
  "Пароль": "Password",
  "Отправляем…": "Sending...",
  "Отправить ссылку": "Send link",
  "Подождите…": "Please wait...",
  "Войти": "Sign in",
  "Регистрация": "Sign up",
  "Забыли пароль?": "Forgot password?",
  "или": "or",
  "Продолжить с Google": "Continue with Google",
  "Попробовать демо": "Try the demo",
  "Проверяем демо…": "Checking the demo...",
  "Продолжить демо": "Continue demo",
  "Продолжаем демо…": "Continuing the demo...",
  "Начать новое демо": "Start a new demo",
  "Подготавливаем демо…": "Preparing the demo...",
  "Предыдущее демо больше недоступно. Можно начать новую демо-песочницу.": "The previous demo is no longer available. You can start a new demo sandbox.",
  "Не удалось продолжить демо. Попробуйте ещё раз.": "Could not continue the demo. Please try again.",
  "Не удалось открыть демо. Попробуйте позже.": "Could not open the demo. Please try again later.",
  "Демо-сервер недоступен или ещё не обновлён.": "The demo server is unavailable or has not been updated yet.",
  "Сервер вернул некорректную демо-сессию": "The server returned an invalid demo session",
  "Не удалось открыть созданную демо-сессию": "Could not open the created demo session",
  "Перезапуск доступен только в демо-режиме": "Restart is only available in demo mode",
  "Новая демо-сессия готова": "A new demo session is ready",
  "Не удалось начать демо заново. Попробуйте ещё раз.": "Could not restart the demo. Please try again.",
  "Демо-режим": "Demo mode",
  "Демо-песочница": "Demo sandbox",
  "оценки и игровой выбор сохраняются только в этом браузере": "ratings and game choices are saved only in this browser",
  "Можно закрыть сайт и продолжить демо позже на этом устройстве.": "You can close the site and continue the demo later on this device.",
  "Можно закрыть сайт и продолжить демо позже на этом устройстве. Демо-профиль доступен 14 дней с момента создания.": "You can close the site and continue the demo later on this device. The demo profile remains available for 14 days after it is created.",
  "Демо-профиль будет доступен в этом браузере 14 дней с момента создания.": "The demo profile will remain available in this browser for 14 days after it is created.",
  "Эта функция доступна для зарегистрированных профилей. Создайте аккаунт, чтобы сохранить прогресс и делиться достижениями.": "This feature is available to registered profiles. Create an account to save your progress and share achievements.",
  "Создать аккаунт": "Create account",
  "Создаём…": "Creating...",
  "Начать заново": "Start over",
  "Страница не загрузилась": "The page failed to load",
  "Произошла непредвиденная ошибка. Ваши оценки не удалены. Попробуйте обновить страницу.": "An unexpected error occurred. Your ratings have not been deleted. Try refreshing the page.",
  "Обновить страницу": "Refresh page",
  "На главную": "Home",
  "Введите корректный адрес электронной почты.": "Enter a valid email address.",
  "Этот email уже зарегистрирован. Переключитесь на вход.": "This email is already registered. Switch to sign in.",
  "Пароль должен содержать не менее 6 символов.": "Password must be at least 6 characters.",
  "Этот аккаунт отключён.": "This account is disabled.",
  "Этот аккаунт отключен.": "This account is disabled.",
  "Аккаунт с таким email не найден.": "No account found for this email.",
  "Неверный email или пароль.": "Incorrect email or password.",
  "Слишком много попыток. Попробуйте немного позже.": "Too many attempts. Try again a little later.",
  "Нет соединения с сервером. Проверьте интернет.": "No server connection. Check your internet.",
  "Браузер заблокировал окно Google. Разрешите всплывающие окна.": "The browser blocked the Google window. Allow pop-ups.",
  "Окно входа Google было закрыто.": "The Google sign-in window was closed.",
  "Окно входа Google уже открыто.": "The Google sign-in window is already open.",
  "Этот способ авторизации не включён в Firebase.": "This sign-in method is not enabled in Firebase.",
  "Этот способ авторизации не включен в Firebase.": "This sign-in method is not enabled in Firebase.",
  "Этот email уже используется с другим способом входа. Войдите по email и паролю.": "This email is already used with another sign-in method. Sign in with email and password.",
  "Вход выполнен, но профиль не удалось сохранить. Попробуйте ещё раз.": "Signed in, but the profile could not be saved. Please try again.",
  "Вход выполнен, но профиль не удалось сохранить. Попробуйте еще раз.": "Signed in, but the profile could not be saved. Please try again.",
  "Введите email.": "Enter email.",
  "Не удалось выполнить вход. Попробуйте ещё раз.": "Could not sign in. Please try again.",
  "Не удалось выполнить вход. Попробуйте еще раз.": "Could not sign in. Please try again.",

  "Выбрать CSV-файл": "Choose CSV file",
  "Этапы импорта": "Import steps",
  "Выберите CSV-файл": "Choose a CSV file",
  "Проверьте найденные данные": "Review the detected data",
  "Подтвердите импорт": "Confirm the import",
  "Импортировано": "Imported",
  "Импорт оценок завершён": "Ratings import complete",
  "Импорт завершен": "Import complete",
  "Импорт завершён": "Import complete",
  "записей перенесено": "records imported",
  "фильмов перенесено": "movies imported",
  "Не перенесено:": "Not imported:",
  "Пропущено при чтении:": "Skipped while reading:",
  "Новые достижения:": "New achievements:",
  "Новые уровни:": "New levels:",
  "Список фильмов и сериалов, которые не перенеслись": "Movies and series that were not imported",
  "Импортируем": "Importing",
  "Сейчас:": "Now:",
  "Всего к импорту:": "Total to import:",
  "Найдено для импорта:": "Found to import:",
  "Переносим...": "Importing...",
  "Импортировать списки": "Import lists",
  "Импортировать оценки": "Import ratings",
  "Список IMDb будет импортирован в «Буду смотреть».": "The IMDb list will be imported into Watchlist.",
  "Определён файл со списками": "Detected a list file",
  "Определен файл со списками": "Detected a list file",
  "Определён файл с оценками": "Detected a ratings file",
  "Определен файл с оценками": "Detected a ratings file",
  "Найдено строк:": "Rows found:",
  "Обработка:": "Processing:",
  "Фильм не найден": "Movie not found",
  "Фильм или список не найден": "Movie or list not found",
  "Найден другой тип с тем же id TMDB": "Found another media type with the same TMDB ID",
  "Ошибка импорта": "Import error",
  "Импорт остановлен:": "Import stopped:",
  "Строка": "Row",
  "не удалось сохранить данные": "could not save data",
  "Сейчас поддерживаются CSV/TSV. В таблице выберите «Сохранить как CSV» и загрузите этот файл.": "CSV/TSV is currently supported. In the spreadsheet, choose “Save as CSV” and upload that file.",
  "Не удалось импортировать файл.": "Could not import the file.",
  "Отсутствует обязательный столбец": "A required column is missing:",
  "Отсутствуют обязательные столбцы": "Required columns are missing",
  "Проверьте, что выбран правильный CSV-файл и его структура не была изменена.": "Make sure you selected the correct CSV file and that its structure has not been changed.",
  "Не удалось определить тип файла. Загрузите CSV с колонками ListTitle, Date и Title/Original Title для списков или My rating, Date и Title/Original Title для оценок.": "Could not detect the file type. Upload a CSV with ListTitle, Date and Title/Original Title columns for lists, or My rating, Date and Title/Original Title columns for ratings.",
  "Вы можете перенести на CineParagon свои старые оценки и списки фильмов, если у вас есть файл с данными в формате CSV.": "You can move your old ratings and movie lists to CineParagon if you have a CSV data file.",
  "Многие сервисы позволяют экспортировать ваши собственные данные: оценки, просмотренные фильмы, списки и избранное. Если ваши оценки находятся на другом сайте, сначала получите файл с вашими данными, а затем загрузите его сюда.": "Many services let you export your own data: ratings, watched movies, lists and favorites. If your ratings are on another site, first get a file with your data and then upload it here.",
  "Сейчас поддерживается импорт резервной копии Kinorium.": "Importing a Kinorium backup is currently supported.",
  "Сейчас поддерживаются резервные копии Kinorium и CSV-экспорты IMDb.": "Kinorium backups and IMDb CSV exports are currently supported.",
  "Что можно импортировать": "What can be imported",
  "Вы можете импортировать:": "You can import:",
  "оценки фильмов;": "movie ratings;",
  "просмотренные фильмы;": "watched movies;",
  "списки фильмов;": "movie lists;",
  "списки актёров и других персон, если они есть в резервной копии.": "actor and other person lists, if they are included in the backup.",
  "списки актеров и других персон, если они есть в резервной копии.": "actor and other person lists, if they are included in the backup.",
  "После импорта данные появятся в вашем профиле, статистике, дневнике и списках.": "After import, the data will appear in your profile, statistics, diary and lists.",
  "После импорта данные появятся в профиле, статистике, дневнике и списках.": "After import, the data will appear in your profile, statistics, diary and lists.",
  "Важно про серии и опыт": "Important: streaks and XP",
  "Импорт старых оценок нужен для восстановления вашей истории просмотров.": "Old rating import is for restoring your viewing history.",
  "Старые оценки из файла добавляются в историю, статистику и коллекцию, но не создают искусственную недельную серию и не выдают игровые награды задним числом.": "Old ratings from the file are added to your history, statistics and collection, but do not create an artificial weekly streak or award game rewards retroactively.",
  "Новые фильмы, оценённые после импорта, участвуют в текущей активности, сериях, достижениях и испытаниях по обычным правилам.": "New movies rated after import take part in current activity, streaks, achievements and challenges under the normal rules.",
  "Чтобы импорт не ломал игровую систему, старые оценки из файла не засчитываются как фильмы, просмотренные на этой неделе. Они добавляются в вашу историю, статистику и коллекцию, но не создают искусственную недельную серию.": "To keep the game system fair, old ratings from the file do not count as movies watched this week. They are added to your history, statistics and collection, but do not create an artificial weekly streak.",
  "Новые фильмы, которые вы будете оценивать после импорта, уже будут учитываться в текущей активности, сериях, достижениях и испытаниях по обычным правилам.": "New movies you rate after import will count toward current activity, streaks, achievements and challenges under the normal rules.",
  "Как получить файл из Kinorium": "How to get a file from Kinorium",
  "Как получить файл из IMDb": "How to get a file from IMDb",
  "Шаг 1. Войдите в IMDb": "Step 1. Sign in to IMDb",
  "Откройте IMDb в браузере и войдите в свой аккаунт.": "Open IMDb in your browser and sign in to your account.",
  "Шаг 2. Откройте оценки или список": "Step 2. Open your ratings or a list",
  "Чтобы экспортировать оценки, откройте меню профиля и выберите «Ваши оценки».": "To export ratings, open the profile menu and choose “Your ratings”.",
  "Чтобы экспортировать список фильмов, откройте нужный список, например Watchlist.": "To export a movie list, open the list you need, such as Watchlist.",
  "Шаг 3. Экспортируйте CSV-файл": "Step 3. Export the CSV file",
  "Нажмите на значок «Экспорт» в правом верхнем углу. IMDb скачает файл в формате CSV.": "Click the “Export” icon in the top-right corner. IMDb will download a CSV file.",
  "Шаг 4. Загрузите файл сюда": "Step 4. Upload the file here",
  "Выберите скачанный CSV-файл, проверьте предпросмотр и подтвердите импорт.": "Choose the downloaded CSV file, review the preview and confirm the import.",
  "Оценки и списки экспортируются отдельными файлами; загрузите их по очереди.": "Ratings and lists are exported as separate files; upload them one at a time.",
  "Шаг 1. Войдите в Kinorium": "Step 1. Sign in to Kinorium",
  "Если оценки находятся на другом сайте, сначала перенесите их в Kinorium штатным способом.": "If your ratings are on another site, first move them to Kinorium using its standard import method.",
  "Шаг 1. Зарегистрируйтесь или войдите в Kinorium": "Step 1. Register or sign in to Kinorium",
  "Откройте Kinorium и войдите в свой аккаунт.": "Open Kinorium and sign in to your account.",
  "Если у вас уже есть оценки в Kinorium, переходите сразу к шагу с резервной копией.": "If you already have ratings in Kinorium, skip straight to the backup step.",
  "Если ваши оценки находятся на другом сайте, сначала перенесите их в Kinorium стандартным способом, который предлагает сам Kinorium.": "If your ratings are on another site, first move them to Kinorium using Kinorium's standard method.",
  "Шаг 2. Откройте настройки профиля": "Step 2. Open profile settings",
  "В меню профиля выберите «Настройки», затем найдите импорт данных.": "In the profile menu, choose “Settings”, then find data import.",
  "Шаг 3. Дождитесь импорта данных": "Step 3. Wait for the data import",
  "Проверьте, что оценки появились в профиле Kinorium.": "Check that the ratings appeared in your Kinorium profile.",
  "Шаг 4. Откройте резервное копирование": "Step 4. Open backup",
  "В настройках откройте раздел «Резервное копирование» и включите оценки, просмотры и нужные списки.": "In settings, open “Backup” and include ratings, views and the lists you need.",
  "Шаг 5. Получите CSV-файлы": "Step 5. Get the CSV files",
  "Kinorium отправит письмо с файлами оценок, списков фильмов и, при наличии, списков персон.": "Kinorium will send an email with ratings files, movie lists and, if available, person lists.",
  "Шаг 6. Загрузите файл сюда": "Step 6. Upload the file here",
  "Выберите полученный CSV-файл, проверьте предпросмотр и подтвердите импорт.": "Choose the CSV file, review the preview and confirm the import.",
  "Нажмите на иконку своего профиля в правом верхнем углу.": "Click your profile icon in the top-right corner.",
  "В открывшемся меню выберите пункт «Настройки».": "In the menu that opens, choose “Settings”.",
  "Шаг 3. Найдите импорт данных": "Step 3. Find data import",
  "В настройках Kinorium найдите блок импорта данных.": "In Kinorium settings, find the data import block.",
  "Если вы переносите оценки из Кинопоиска, выберите импорт данных из Кинопоиска и следуйте инструкции Kinorium.": "If you are moving ratings from Kinopoisk, choose Kinopoisk data import and follow Kinorium's instructions.",
  "Обычно для этого нужно указать ссылку на ваш публичный профиль. Убедитесь, что ваши оценки и списки доступны для импорта.": "Usually you need to provide a link to your public profile. Make sure your ratings and lists are available for import.",
  "Шаг 4. Дождитесь завершения импорта": "Step 4. Wait for the import to finish",
  "Импорт может занять некоторое время.": "Import can take some time.",
  "После завершения проверьте, что оценки появились в вашем профиле Kinorium.": "After it finishes, check that the ratings appeared in your Kinorium profile.",
  "Шаг 5. Откройте резервное копирование": "Step 5. Open backup",
  "Вернитесь в настройки Kinorium.": "Return to Kinorium settings.",
  "Откройте раздел «Резервное копирование».": "Open the “Backup” section.",
  "Шаг 6. Выберите данные для экспорта": "Step 6. Choose data to export",
  "Отметьте данные, которые хотите получить в файле.": "Select the data you want to receive in the file.",
  "Рекомендуется включить:": "Recommended to include:",
  "оценки и просмотры;": "ratings and views;",
  "списки актёров, если вы хотите перенести и их.": "actor lists, if you want to move them too.",
  "списки актеров, если вы хотите перенести и их.": "actor lists, if you want to move them too.",
  "После этого нажмите кнопку отправки файла на почту.": "After that, click the button to send the file by email.",
  "Шаг 7. Получите письмо с файлами": "Step 7. Get the email with files",
  "Kinorium отправит письмо на вашу почту.": "Kinorium will send an email to your inbox.",
  "В письме будут прикреплены файлы с вашими данными. Обычно это несколько CSV-файлов, например:": "The email will include files with your data. Usually these are several CSV files, for example:",
  "файл с оценками;": "a ratings file;",
  "файл со списками фильмов;": "a movie lists file;",
  "файл со списками персон.": "a person lists file.",
  "Скачайте эти файлы на компьютер или телефон.": "Download these files to your computer or phone.",
  "Шаг 8. Загрузите файл на CineParagon": "Step 8. Upload the file to CineParagon",
  "Вернитесь на CineParagon.": "Return to CineParagon.",
  "Откройте страницу импорта.": "Open the import page.",
  "Выберите полученный CSV-файл и нажмите «Импортировать».": "Choose the CSV file you received and click “Import”.",
  "Если у вас несколько файлов, загрузите их по очереди.": "If you have several files, upload them one by one.",
  "Шаг 9. Проверьте результат": "Step 9. Check the result",
  "После импорта откройте профиль, статистику и списки.": "After import, open your profile, statistics and lists.",
  "Проверьте, что оценки и фильмы появились корректно.": "Check that ratings and movies appeared correctly.",
  "Если часть фильмов не нашлась автоматически, их можно будет добавить вручную позже.": "If some movies were not found automatically, you can add them manually later.",
  "Если что-то пошло не так": "If something went wrong",
  "Проверьте, что загружен CSV-файл без ручного изменения структуры.": "Check that the uploaded CSV file has not had its structure edited manually.",
  "Если импорт не сработал, скачайте резервную копию повторно и попробуйте ещё раз.": "If the import did not work, download the backup again and try once more.",
  "Если импорт не сработал, экспортируйте CSV-файл из IMDb повторно и попробуйте ещё раз.": "If the import did not work, export a new CSV file from IMDb and try again.",
  "Проверьте, что вы загрузили именно CSV-файл.": "Check that you uploaded a CSV file.",
  "Убедитесь, что файл не был переименован или изменён вручную.": "Make sure the file was not renamed or edited manually.",
  "Убедитесь, что файл не был переименован или изменен вручную.": "Make sure the file was not renamed or edited manually.",
  "Если импорт не сработал, попробуйте скачать резервную копию повторно.": "If the import did not work, try downloading the backup again.",
  "Если проблема остаётся, напишите в поддержку и приложите описание ошибки.": "If the problem remains, contact support and attach a description of the error.",
  "Если проблема остается, напишите в поддержку и приложите описание ошибки.": "If the problem remains, contact support and attach a description of the error.",
  "Эта инструкция описывает использование стандартных возможностей Kinorium по импорту, экспорту и резервному копированию пользовательских данных.": "This guide describes using Kinorium's standard features for importing, exporting and backing up user data.",
  "Эта инструкция описывает использование стандартных возможностей IMDb по экспорту пользовательских данных.": "This guide describes using IMDb's standard user-data export features.",
  "CineParagon не связан с Kinorium, Кинопоиском, IMDb или другими внешними сервисами, не является их официальным партнёром и не представляет их интересы.": "CineParagon is not affiliated with Kinorium, Kinopoisk, IMDb or other external services, is not their official partner and does not represent them.",
  "CineParagon не связан с Kinorium, Кинопоиском, IMDb или другими внешними сервисами, не является их официальным партнером и не представляет их интересы.": "CineParagon is not affiliated with Kinorium, Kinopoisk, IMDb or other external services, is not their official partner and does not represent them.",
  "Пользователь самостоятельно получает файл со своими данными и самостоятельно загружает его на CineParagon.": "The user obtains the file with their data independently and uploads it to CineParagon independently.",
  "CineParagon не запрашивает логин или пароль от сторонних сервисов, не выполняет вход в аккаунт пользователя на других сайтах и не обходит технические ограничения сторонних платформ.": "CineParagon does not request a login or password for third-party services, does not sign in to the user's account on other sites and does not bypass technical restrictions of third-party platforms.",
  "Ещё не получено": "Not earned yet",

  "Впечатление": "Impression",
  "В тексте есть спойлеры": "Contains spoilers",
  "Заголовок рецензии": "Review title",
  "Расскажите, что вы думаете о фильме...": "Tell what you think about the movie...",
  "Сохранение...": "Saving...",
  "Опубликовать": "Publish",
  "Загрузка рецензий...": "Loading reviews...",
  "К этому фильму пока что не написали рецензий.": "No reviews have been written for this movie yet.",
  "Удалить рецензию": "Delete review",
  "Удалить рецензию?": "Delete review?",
  "Рецензия и все голоса за неё будут удалены.": "The review and all votes for it will be deleted.",
  "Рецензия и все голоса за нее будут удалены.": "The review and all votes for it will be deleted.",
  "В рецензии есть спойлеры — показать текст": "This review contains spoilers — show text",
  "Была ли рецензия полезна?": "Was this review helpful?",
  "Полезно": "Helpful",
  "изменено": "edited",
  "Для публикации рецензии необходимо войти в аккаунт.": "Sign in to publish a review.",
  "Добавьте заголовок и напишите не менее 50 символов.": "Add a title and write at least 50 characters.",
  "Не удалось загрузить рецензии.": "Could not load reviews.",
  "Не удалось сохранить рецензию. Попробуйте ещё раз.": "Could not save the review. Please try again.",
  "Не удалось сохранить рецензию. Попробуйте еще раз.": "Could not save the review. Please try again.",
  "Не удалось удалить рецензию.": "Could not delete the review.",
  "Не удалось сохранить голос за рецензию.": "Could not save the review vote.",
  "Это демо-профиль. Создайте аккаунт, чтобы оценивать рецензии.": "This is a demo profile. Create an account to rate reviews.",

  "Доступна": "Available",
  "Не выпала": "Not dropped",
  "Истёк": "Expired",
  "Истек": "Expired",
  "Соло-недельная": "Solo weekly",
  "до вторника, 23:59": "until Tuesday, 23:59",
  "до четверга, 23:59": "until Thursday, 23:59",
  "до воскресенья, 23:59": "until Sunday, 23:59",
  "Экспедиция выбрана. Первый таймер запущен.": "Expedition selected. The first timer has started.",
  "Не удалось выбрать экспедицию. Попробуйте обновить страницу.": "Could not choose the expedition. Try refreshing the page.",
  "Время окончания уточняется": "End time is being clarified",
  "Завершён": "Completed",
  "Завершен": "Completed",
  "Не пройдена: удалена зачтённая оценка": "Not completed: counted rating was deleted",
  "Не пройдена: удалена зачтенная оценка": "Not completed: counted rating was deleted",
  "Этап не пройден": "Stage failed",
  "В путь": "Let's go",

  "Испытание добавлено в профиль": "Challenge added to profile",
  "Лёгкое": "Easy",
  "Легкое": "Easy",
  "Нормальное": "Normal",
  "Сложное": "Hard",
  "Очень сложное": "Very hard",
  "Невозможное": "Impossible",
  "Закрыть драму, комедию и триллер": "Complete drama, comedy and thriller",
  "Посмотреть фильмы пяти жанров: драма, комедия, триллер, фантастика и мультфильм": "Watch movies in all five genres: drama, comedy, thriller, science fiction, and animation",
  "Посмотрите 12 фильмов жанров: драма, комедия, фантастика или мультфильм": "Watch 12 movies in these genres: drama, comedy, science fiction, or animation",
  "Закрыть любой континент": "Complete any continent",
  "5 стран Европы, 5 Азии, 3 Северной и 3 Южной Америки": "5 countries in Europe, 5 in Asia, 3 in North America and 3 in South America",
  "10 оценок 8+, 10 жанров и 10 стран": "10 ratings of 8+, 10 genres and 10 countries",
  "100 фильмов, 50 стран, 25 жанров и 25 годов": "100 movies, 50 countries, 25 genres and 25 years",
  "10 стран Европы, 10 Азии, 5 Северной Америки, 5 Южной Америки и 5 Африки": "10 countries in Europe, 10 in Asia, 5 in North America, 5 in South America and 5 in Africa",
  "20 стран, 20 жанров, 10 десятилетий и 20 режиссёров": "20 countries, 20 genres, 10 decades and 20 directors",
  "20 стран, 20 жанров, 10 десятилетий и 20 режиссеров": "20 countries, 20 genres, 10 decades and 20 directors",
  "Посмотреть по фильму за каждый год начиная с 1895": "Watch one movie for every year starting from 1895",
  "Посмотреть фильмы на 3 языках оригинала": "Watch movies in 3 original languages",
  "Посмотреть фильмы на 10 языках оригинала": "Watch movies in 10 original languages",
  "Посмотреть фильмы на 25 языках оригинала": "Watch movies in 25 original languages",
  "Посмотреть 3 сериала": "Watch 3 series",
  "Посмотреть 10 сериалов": "Watch 10 series",
  "Условия зачёта:": "Scoring conditions:",
  "Общие правила зачёта": "General scoring rules",
  "Засчитываются подходящие фильмы и сериалы, впервые оценённые после запуска испытания и до истечения его срока.": "Eligible movies and series count when first rated after the challenge starts and before its deadline.",
  "Импортированные и архивные оценки, а также короткометражные фильмы, в прогресс испытаний не входят.": "Imported and archive ratings, as well as short films, do not count toward challenge progress.",
  "Один фильм даёт не больше одного деления в одном испытании или экспедиции, но может одновременно подойти нескольким разным испытаниям, картам недели и экспедиции.": "One title grants at most one step in a single challenge or expedition, but it may count toward multiple different challenges, weekly cards, and an expedition at the same time.",
  "Удаление зачтённой оценки отзывает её прогресс. После удаления повторная оценка начинает новый жизненный цикл и засчитывается, если сделана во время активного испытания.": "Deleting a counted rating revokes its progress. Rating the title again starts a new lifecycle and counts if it happens while the challenge is active.",
  "Каждый новый оценённый фильм или сериал даёт одно деление.": "Each newly rated movie or series grants one step.",
  "Засчитывается не больше одного фильма за календарный день; для каждого деления нужен новый день.": "At most one movie counts per calendar day; each step requires a new day.",
  "Каждый отдельный фильм из подходящей страны даёт одно деление.": "Each separate title from an eligible country grants one step.",
  "Для уникальных стран каждое деление требует отдельного фильма и отдельной подходящей страны.": "For unique-country goals, each step requires a separate title and a separate eligible country.",
  "Каждый отдельный фильм подходящего жанра даёт одно деление.": "Each separate title in an eligible genre grants one step.",
  "Для разных жанров каждый фильм закрепляется только за одним жанром этого испытания.": "For distinct-genre goals, each title is assigned to only one genre in that challenge.",
  "В зачёт идут отдельные фильмы одного и того же жанра; один фильм даёт одно деление.": "Separate titles in the same genre count; one title grants one step.",
  "Каждый отдельный фильм из подходящего десятилетия даёт одно деление.": "Each separate title from an eligible decade grants one step.",
  "Каждое деление требует отдельного фильма из нового подходящего десятилетия.": "Each step requires a separate title from a new eligible decade.",
  "В зачёт идут отдельные фильмы с одним и тем же подходящим актёром.": "Separate titles featuring the same eligible actor count.",
  "В зачёт идут отдельные фильмы одного и того же подходящего режиссёра.": "Separate titles by the same eligible director count.",
  "В зачёт идут отдельные фильмы одного и того же подходящего композитора.": "Separate titles by the same eligible composer count.",
  "Каждый отдельный фильм подходящего года даёт одно деление.": "Each separate title from an eligible year grants one step.",
  "Для разных годов каждое деление требует отдельного фильма нового подходящего года.": "For distinct-year goals, each step requires a separate title from a new eligible year.",
  "Суммируется хронометраж, но один фильм добавляет не больше одного часа и одного деления.": "Runtime is accumulated, but one title adds at most one hour and one step.",
  "Один отдельно оценённый фильм или сериал даёт не больше одного деления; сезоны одного сериала не дублируют прогресс.": "A separately rated movie or series grants at most one step; seasons of the same series do not duplicate progress.",
  "Каждая подходящая оценка отдельного фильма или сериала даёт одно деление.": "Each eligible rating of a separate movie or series grants one step.",
  "Учитывается язык оригинала, а не языки дубляжа или перевода: нужны разные языки и отдельный фильм для каждого языка.": "The original language is used, not dubbing or translation languages: each language and each title must be different.",
  "Фильм закрепляется только за одним из перечисленных условий; повторяющиеся страны, жанры, годы и персоны не дублируют прогресс.": "A title is assigned to only one listed condition; repeated countries, genres, years, and people do not duplicate progress.",

  "январь": "January",
  "февраль": "February",
  "март": "March",
  "апрель": "April",
  "май": "May",
  "июнь": "June",
  "июль": "July",
  "август": "August",
  "сентябрь": "September",
  "октябрь": "October",
  "ноябрь": "November",
  "декабрь": "December",
  "января": "January",
  "февраля": "February",
  "марта": "March",
  "апреля": "April",
  "мая": "May",
  "июня": "June",
  "июля": "July",
  "августа": "August",
  "сентября": "September",
  "октября": "October",
  "ноября": "November",
  "декабря": "December",

  "фильм": "movie",
  "фильма": "movies",
  "фильмов": "movies",
  "Категория": "Category",
  "Период": "Period",
  "Вы": "You",
  "Показать фильмы": "Show movies",
  "страна": "country",
  "жанр": "genre",
  "Группировка по времени": "Time grouping",
  "Рассчитывается разница": "Calculating difference",
  "Рассчитывается разница жанра": "Calculating genre difference",
  "Разница по количеству фильмов": "Difference in movie count",
  "Разница средней оценки": "Average rating difference",
  "Средняя оценка друга": "Friend's average rating",
  "Ваша средняя оценка": "Your average rating",
  "Разница оценок": "Rating difference",
  "Фильмов у друга": "Friend's movies",
  "Фильмов у вас": "Your movies",
  "Разница": "Difference",
  "Подготавливаем статистику съёмочной группы...": "Preparing cast and crew statistics...",
  "Подготавливаем статистику съемочной группы...": "Preparing cast and crew statistics...",
  "Фильмы пользователя": "User's movies",
  "Ваши фильмы": "Your movies",
  "Нет фильмов в этой категории": "No movies in this category",
  "Закрыть список фильмов": "Close movie list",
  "Ошибка загрузки данных": "Data loading error",
  "Тут пока ещё нет данных для отображения.": "There is no data to show yet.",
  "Тут пока еще нет данных для отображения.": "There is no data to show yet.",
  "Начните оценивать фильмы,": "Start rating movies,",
  "чтобы увидеть статистику.": "to see statistics.",
  "Загрузка графика...": "Loading chart...",
  "Подготавливаем карту...": "Preparing map...",
  "Ошибка загрузки карты": "Map loading error",
  "Загрузка карты...": "Loading map...",
  "Оценки друга": "Friend's ratings",
  "Ваши оценки": "Your ratings",
  "Оригинальность": "Originality",
  "Логичность и структура": "Logic and structure",
  "Работа актеров": "Acting",
  "Работа актёров": "Acting",
  "Визуальная составляющая": "Visuals",
  "Музыка": "Music",
  "Глубина": "Depth",
  "Эмоциональная вовлеченность": "Emotional engagement",
  "Эмоциональная вовлечённость": "Emotional engagement",
  "Атмосфера": "Atmosphere",
  "Диалоги": "Dialogue",
  "Послевкусие": "Aftertaste",
  "Стиль и визуальная эстетика": "Style and visual aesthetics",
  "Темп и ритм": "Pace and rhythm",
  "Эмоциональная выразительность": "Emotional expressiveness",
  "Химия между актерами": "Chemistry between actors",
  "Химия между актёрами": "Chemistry between actors",
  "Композиция и динамика кадров": "Composition and shot dynamics",
  "Использование света и тени": "Use of light and shadow",
  "Качество звукового оформления": "Sound design quality",
  "Влияние музыки на атмосферу": "Music impact on atmosphere",
  "Связность сцен и использование переходов": "Scene cohesion and transitions",
  "Детализация костюмов/грима/декораций": "Costumes, makeup and sets detail",
  "Качество визуальных эффектов": "Visual effects quality",
  "Глубина тематики": "Thematic depth",
  "Социальное и культурное влияние": "Social and cultural impact",
  "Запоминаемость сцен": "Scene memorability",
  "Кастинг и соответствие ролей": "Casting and role fit",
  "Исторический контекст и вклад в жанр": "Historical context and genre contribution",
  "Индивидуальные восприятия": "Individual perception",
  "Жел.": "Iron",
  "Бронз.": "Bronze",
  "Сереб.": "Silver",
  "Зол.": "Gold",
  "Плат.": "Platinum",
  "Алм.": "Diamond",
  "Легенд.": "Legendary",
  "Железная": "Iron",
  "Бронзовая": "Bronze",
  "Серебряная": "Silver",
  "Золотая": "Gold",
  "Платиновая": "Platinum",
  "Алмазная": "Diamond",
  "Нет": "None",
  "Пока": "Currently",
  "Недели": "Weeks",
  "Недель": "Weeks",
  "Недели друга": "Friend's weeks",
  "Ваши недели": "Your weeks",
  "Загрузка графика недель...": "Loading weeks chart...",
  "Эта неделя": "This week",
  "Недельные серии": "Weekly streaks",
  "Поддерживайте серию просмотров, повышайте качество каждой недели и получайте всё больше опыта за свою активность.": "Keep your watch streak going, raise the quality of each week and earn more XP for your activity.",
  "Поддерживайте серию просмотров, повышайте качество каждой недели и получайте все больше опыта за свою активность.": "Keep your watch streak going, raise the quality of each week and earn more XP for your activity.",
  "Каждая неделя состоит из двух независимых частей:": "Each week has two independent parts:",
  "Серия": "Streak",
  "Показывает, сколько недель подряд вы оставались активным киноманом.": "Shows how many weeks in a row you stayed an active cinephile.",
  "Зависит от количества фильмов, просмотренных за текущую неделю, и определяет размер бонусной награды.": "Depends on the number of movies watched during the current week and determines the bonus reward.",
  "1+ фильм за неделю": "1+ movie in a week",
  "3+ фильма за неделю": "3+ movies in a week",
  "5+ фильмов за неделю": "5+ movies in a week",
  "7+ фильмов за неделю": "7+ movies in a week",
  "14+ фильмов за неделю": "14+ movies in a week",
  "21+ фильм за неделю": "21+ movies in a week",
  "28+ фильмов за неделю": "28+ movies in a week",
  "Серия активности": "Activity streak",
  "Справка по сериям": "Streak help",
  "Неделя начинается в понедельник и заканчивается в воскресенье.": "A week starts on Monday and ends on Sunday.",
  "Чтобы продолжить серию, достаточно оценить хотя бы один фильм за неделю.": "To continue the streak, rating at least one movie during the week is enough.",
  "За каждую новую неделю серии вы получаете дополнительный опыт.": "For every new week in the streak you earn extra XP.",
  "Формула": "Formula",
  "номер недели": "week number",
  "Например:": "For example:",
  "10-я неделя — +20 опыта": "week 10 — +20 XP",
  "25-я неделя — +35 опыта": "week 25 — +35 XP",
  "50-я неделя — +60 опыта": "week 50 — +60 XP",
  "Пропуски и защита": "Misses and protection",
  "Если за неделю не был оценён ни один фильм, один раз в месяц автоматически срабатывает защита серии.": "If no movie was rated during a week, streak protection triggers automatically once per month.",
  "Если за неделю не был оценен ни один фильм, один раз в месяц автоматически срабатывает защита серии.": "If no movie was rated during a week, streak protection triggers automatically once per month.",
  "Если защита уже использована, длина серии уменьшается на 25% (с округлением вниз).": "If protection has already been used, the streak length is reduced by 25% (rounded down).",
  "Серия выполнена!": "Streak completed!",
  "Защита месяца": "Month protection",
  "доступна": "available",
  "использована": "used",
  "100 недель → 75 недель": "100 weeks → 75 weeks",
  "50 недель → 37 недель": "50 weeks → 37 weeks",
  "10 недель → 7 недель": "10 weeks → 7 weeks",
  "Важно": "Important",
  "Серия и качество недели работают независимо друг от друга.": "Streak and week quality work independently of each other.",
  "Можно:": "You can:",
  "поддерживать длинную серию, оценивая всего один фильм в неделю;": "keep a long streak by rating just one movie per week;",
  "в любой момент получить более высокий ранг недели, посмотрев больше фильмов;": "raise the week's rank at any time by watching more movies;",
  "после легендарной недели продолжить серию всего одним фильмом — накопленный прогресс качества недель сохранится.": "after a legendary week, continue the streak with just one movie — accumulated week-quality progress is preserved.",
  "Справка по недельным сериям": "Weekly streak help",

  "Фон профиля": "Profile background",
  "Сменить фон профиля": "Change profile cover",
  "Обработка изображения": "Processing image",
  "Изменить аватар": "Change avatar",
  "Сохранить возраст": "Save age",
  "Редактировать возраст": "Edit age",
  "Отменить": "Cancel",
  "Без имени": "No name",
  "Пользователь": "User",
  "Загрузка друзей...": "Loading friends...",
  "Вы пока еще не добавили друзей": "You have not added friends yet",
  "Вы пока ещё не добавили друзей": "You have not added friends yet",
  "Введите имя": "Enter name",
  "Добавить в друзья": "Add friend",
  "Без подписи": "No title",
  "Изменить титул": "Edit title",
  "Добавить титул": "Add title",
  "Сохранить имя": "Save name",
  "Изменить имя": "Edit name",
  "Не удалось сохранить титул": "Could not save title",
  "Не удалось загрузить аватар": "Could not load avatar",
  "Имя не может быть пустым": "Name cannot be empty",
  "Имя обновлено": "Name updated",
  "Не удалось сохранить имя": "Could not save name",
  "Пользователь удалён из друзей": "User removed from friends",
  "Пользователь удален из друзей": "User removed from friends",
  "Не удалось удалить пользователя из друзей": "Could not remove user from friends",
  "Ссылка на профиль скопирована": "Profile link copied",
  "Не удалось скопировать ссылку": "Could not copy link",
  "Не удалось скопировать ссылку. Попробуйте ещё раз.": "Could not copy the link. Please try again.",
  "Вас добавили в друзья": "You were added as a friend",
  "Новый подписчик": "New follower",
  "добавил вас в друзья.": "added you as a friend.",
  "Добавить его в друзья": "Add them as a friend",
  "Оставить в подписчиках": "Keep as a follower",
  "Вы теперь друзья": "You are now friends",
  "Пользователь оставлен в подписчиках": "User kept as a follower",
  "Не удалось обработать запрос в друзья": "Could not handle friend request",
  "Добавляем...": "Adding...",
  "Хотите добавить пользователя": "Do you want to add user",
  "в друзья?": "as a friend?",
  "Поздравляем!": "Congratulations!",
  "Вы достигли 80 уровня! 🎉 Вы молодец и достигли максимального уровня. Хотите продолжить прокачиваться на легендарной фазе?": "You reached level 80! 🎉 Great job — you reached the max level. Do you want to keep progressing in the legendary phase?",
  "Вы достигли 100 уровня! 🎉 Вы достигли максимального легендарного уровня в приложении!": "You reached level 100! 🎉 You reached the maximum legendary level in the app!",
  "Просмотрено фильмов -": "Movies watched -",
  "Друзей -": "Friends -",
  "Лучшая:": "Best:",
  "Информация о серии": "Streak info",
  "Всего опыта:": "Total XP:",
  "Загрузка опыта": "Loading XP",
  "Собираюсь смотреть": "Planning to Watch",
  "Подготавливаем подборку...": "Preparing collection...",
  "Загрузка подборки...": "Loading collection...",
  "Добавляйте фильмы в ваш список, чтобы увидеть их здесь.": "Add movies to your list to see them here.",
  "Добавляйте фильмы в ваш список,": "Add movies to your list,",
  "чтобы увидеть их здесь.": "to see them here.",
  "Есть личная заметка": "Has a personal note",
  "Видна только вам": "Only visible to you",
  "Развернуть редактор заметки": "Expand note editor",
  "Свернуть редактор заметки": "Collapse note editor",
  "Развернуть заметку": "Expand note",
  "Свернуть заметку": "Collapse note",
  "Изменить заметку": "Edit note",
  "Например: пересмотреть с друзьями, обратить внимание на музыку, хороший фильм для осеннего вечера...": "For example: rewatch with friends, pay attention to the music, a good movie for an autumn evening...",
  "Сохраняем...": "Saving...",
  "Черновик открыт. Разверните блок, чтобы продолжить.": "Draft is open. Expand the block to continue.",
  "Заметка удалена.": "Note deleted.",
  "Заметка сохранена.": "Note saved.",
  "Не удалось загрузить заметку.": "Could not load the note.",
  "Не удалось сохранить заметку.": "Could not save the note.",
  "Не удалось удалить заметку.": "Could not delete the note.",
  "Осталось символов:": "Characters remaining:",
  "Достигнут лимит символов": "Character limit reached",
  "тут будет список всех актрёров фильма": "The movie cast list will appear here",
  "тут будет список лучших актеров": "The best actors list will appear here",
  "тут будет история оценок": "Rating history will appear here",
  "тут будет статистика оценок друзей": "Friends' rating statistics will appear here",
  "тут будет график оценок друзей": "Friends' rating chart will appear here",
  "тут будет график оценок пользователя": "The user's rating chart will appear here",
  "Нет доступных актеров": "No actors available",
  "Показать всех актеров.": "Show all actors.",
  "Избранное": "Favorites",
  "Информация об источниках данных": "Data source information",
  "Критерии детального оценивания": "Detailed rating criteria",
  "В источнике нет данных о сезонах": "The source has no season data",
  "Не удалось загрузить данные по сезонам": "Could not load season data",
  "Данные по сериалу не получены": "Series data was not received",
  "Длительность неизвестна": "Runtime unknown",
  "оценок": "ratings",
  "нет оценок": "no ratings",
  "Сериал ·": "Series ·",
  "Описание не добавлено": "No description added",
  "Оценка и запись просмотра «": "The rating and viewing record for “",
  "» будут удалены из вашей статистики.": "” will be removed from your statistics.",
  "Оценка:": "Rating:",
  "Друг": "Friend",
  "пользователя": "user",
  "из друзей": "from friends",
  ": оценка": ": rating",
  ": просмотрено без оценки": ": watched without a rating",
  "· без оценки:": "· without a rating:",
  "Аватар пользователя": "User avatar",
  "Изменить": "Edit",
  "Увеличить": "Zoom in",
  "Уменьшить": "Zoom out",
  "Сбросить трансформацию": "Reset view",
  "Поставить оценку 0.0": "Set rating to 0.0",
  "Поставить оценку 10.0": "Set rating to 10.0",
  "Загружаем страницу": "Loading page",
  "Всего": "Total",
  "Легенда качества недель": "Week quality legend",
  "Постер фильма": "Movie poster",
  "Вид раздела «Все оценки»": "All Ratings view",
  "График": "Chart",
  "Лента": "Feed",
  "Друг / Вы": "Friend / You",
  "Легенда распределения по оценкам": "Rating distribution legend",
  "Кинокритик Демо": "Demo Film Critic",
  "Демо-друг": "Demo friend",
  "Демо-сценарий": "Demo scenario",
  "Сравните вкусы с кинокритиком": "Compare your taste with a film critic",
  "Социальные действия в демо отключены, но подготовленный друг и сравнение двух наборов оценок доступны полностью.": "Social actions are disabled in the demo, but the prepared friend and full rating comparison are available.",
  "Сравнивайте свои оценки с оценками друзей": "Compare your ratings with your friends' ratings",
  "Перейдите в профиль друга и выберите раздел «Статистика».": "Open your friend's profile and select Statistics.",
  "Открыть статистику друга": "Open friend's statistics",
  "Импорт недоступен в демо-режиме. Здесь можно свободно оценивать фильмы и менять списки вручную.": "Import is unavailable in demo mode. You can freely rate movies and edit lists manually here.",
  "Подготавливаю…": "Preparing...",
  "Поделиться итогами": "Share results",
  "Добавляем…": "Adding...",
  "Ищем фильмы…": "Searching for movies...",
  "Ничего не найдено. Попробуйте изменить запрос.": "Nothing found. Try changing your search.",
  "Не удалось выполнить поиск. Проверьте соединение и попробуйте ещё раз.": "Could not search. Check your connection and try again.",
  "Тест анимированных рамок": "Animated frame test",
  "Поделиться:": "Share:",
  "Прогресс": "Progress",
  "Показатель статистики": "Statistics metric",
  "Количество фильмов": "Movie count",
  "Для средней оценки нужно не менее": "An average rating requires at least",
  "оценённых фильмов с участником.": "rated movies featuring this person.",
  "по оценкам фильмов": "based on movie ratings",
  "Срок начала истёк": "Start deadline passed",
  "Срок начала экспедиций на этой неделе истёк": "This week's expedition start deadline has passed",
  "Карточка достижения CineParagon": "CineParagon achievement card",
  "ДОСТИЖЕНИЕ ПОЛУЧЕНО": "ACHIEVEMENT UNLOCKED",
  "Мой путь в кино продолжается": "My cinema journey continues",
  "Карточка профиля CineParagon": "CineParagon profile card",
  "КИНОПРОФИЛЬ": "MOVIE PROFILE",
  "Мой кино-мир": "My movie world",
  "Смотри. Оценивай. Открывай новое.": "Watch. Rate. Discover.",
  "Карточка киноитогов CineParagon": "CineParagon movie results card",
  "ЛИЧНЫЕ КИНОИТОГИ": "PERSONAL MOVIE RESULTS",
  "средняя": "average",
  "Лучший фильм": "Best movie",
  "Главный жанр": "Top genre",
  "Поделиться карточкой": "Share card",
  "ГОТОВО К ОТПРАВКЕ": "READY TO SHARE",
  "Предпросмотр карточки": "Card preview",
  "Создаём PNG…": "Creating PNG...",
  "Скопировать картинку": "Copy image",
  "Скачать PNG": "Download PNG",
  "Скопировать ссылку": "Copy link",
  "Карточка достижения": "Achievement card",
  "Карточка итогов": "Results card",
  "Карточка профиля": "Profile card",
  "Поделиться статистикой": "Share statistics",
  "Карточка статистики": "Statistics card",
  "Карточка статистики CineParagon": "CineParagon statistics card",
  "МОЯ КИНОСТАТИСТИКА": "MY MOVIE STATISTICS",
  "Моя статистика": "My statistics",
    "Какой статистикой поделиться": "Choose statistics to share",
    "Показатели": "Metrics",
    "Для сезона: «Ещё раз» добавляет пересмотр, «История» позволяет изменить даты, «Количество» задаёт общее число просмотров.": "For a season: ‘Again’ adds a rewatch, ‘History’ lets you edit dates, and ‘Count’ sets the total number of viewings.",
  "Скопировать ссылку с превью": "Copy link with preview",
  "Подготавливаю ссылку…": "Preparing link...",
  "Расширенная карточка итогов": "Extended results card",
  "Расширенная карточка киноитогов CineParagon": "Extended CineParagon movie results card",
  "МОИ КИНОИТОГИ": "MY MOVIE RESULTS",
  "Скопировать PNG": "Copy PNG",
  "Выберите хотя бы один показатель": "Select at least one metric",
  "Показатель": "Metric",
  "Где посмотреть сохранённую оценку?": "Where can I find the saved rating?",
  "Оценка с датой находится в разделе «Статистика → История», в блоке «Все оценки» с видом «Лента».": "Your dated rating is in Statistics → History, in the All ratings section using the Feed view.",
  "Детальная оценка с датой находится в разделе «Статистика → Оценки», в блоке «Детальные оценки».": "Your detailed dated rating is in Statistics → Ratings, in the Detailed ratings section.",
  "Посмотреть": "View",
  "Закрыть подсказку": "Close hint",
  "Подсказка": "Guide",
  "Как оценивать с датой?": "How do dated ratings work?",
  "Как оценивать с датой просмотра": "How to rate with a watch date",
  "Обычная оценка с датой": "Standard dated rating",
  "Детальная оценка с датой": "Detailed dated rating",
  "Повторный просмотр": "Repeat viewing",
  "Как отметить повторный просмотр": "How to add a repeat viewing",
  "Как отметить повторный просмотр?": "How do I add a repeat viewing?",
  "Нажмите «Оценить с датой просмотра».": "Select ‘Rate with watch date’.",
  "Поставьте оценку и выберите дату просмотра.": "Choose a rating and the date you watched it.",
  "Нажмите «Сохранить оценку с датой».": "Select ‘Save rating with date’.",
  "Результат: «Статистика → История → Все оценки», вид «Лента».": "Result: Statistics → History → All ratings, in Feed view.",
  "Статистику по оценкам с датой смотрите на графике «Все оценки» во вкладке «История», в виде «Лента».": "View statistics for dated ratings in the All ratings chart on the History tab, using Feed view.",
  "Открыть график «Все оценки»": "Open the All ratings chart",
  "Откройте «Оценить с датой просмотра» и выберите дату.": "Open ‘Rate with watch date’ and choose a date.",
  "Нажмите «Оценить детально с датой».": "Select ‘Add detailed dated rating’.",
  "Поставьте оценки по критериям и нажмите «Сохранить оценки».": "Rate each criterion and select ‘Save ratings’.",
  "Результат: «Статистика → Оценки → Детальные оценки».": "Result: Statistics → Ratings → Detailed ratings.",
  "Статистику по детальным оценкам с датой смотрите на графике «Детальные оценки» во вкладке «Оценки».": "View statistics for detailed dated ratings in the Detailed ratings chart on the Ratings tab.",
  "Открыть график «Детальные оценки»": "Open the Detailed ratings chart",
  "После сохранения статистику по детальным оценкам смотрите в графике «Детальные оценки».": "After saving, view detailed-rating statistics in the Detailed ratings chart.",
  "Оценки сезонов и эпизодов сохраняются отдельно. Их сравнение и средние значения находятся в статистике сезонов и эпизодов.": "Season and episode ratings are stored separately. Compare them and view their averages in season and episode statistics.",
  "Открыть статистику сезонов и эпизодов": "Open season and episode statistics",
  "Оценка сезона не вычисляется из оценок эпизодов: обе статистики сохраняются и показываются отдельно.": "A season rating is not calculated from episode ratings: both statistics are stored and displayed separately.",
  "Новый просмотр добавится в историю отдельно. Количество и долю пересмотров смотрите в статистике пересмотров.": "The new viewing is added to history separately. View rewatch count and share in rewatch statistics.",
  "Открыть статистику пересмотров": "Open rewatch statistics",
  "После первого просмотра найдите на странице фильма блок «Личная киноистория».": "After the first viewing, find the Personal viewing history section on the film page.",
  "Нажмите «Отметить повторный просмотр».": "Select ‘Add another viewing’.",
  "Выберите дату повторного просмотра. Если точная дата неизвестна, отметьте «Дата неизвестна».": "Choose the repeat viewing date. If you do not know the exact date, select ‘Date unknown’.",
  "При необходимости измените текущую оценку и нажмите «Сохранить».": "Change the current rating if needed, then select ‘Save’.",
  "Запись появится в «Истории просмотров», а статистика пересмотров обновится автоматически.": "The entry will appear in Viewing history and the rewatch statistics will update automatically.",
  "Выберите дату нового просмотра. Он добавится в историю отдельно; текущая оценка изменится только если вы поставите другую.": "Choose the new viewing date. It will be added to history separately; the current rating changes only if you choose a different one.",
  "Как сохранить просмотр или оценку": "How to save a viewing or rating",
  "Что нужно сделать": "What to do",
  "Выберите дату просмотра.": "Choose the viewing date.",
  "Если хотите поставить оценку — выберите звёзды. Без звёзд сохранится только просмотр.": "Choose stars if you want to rate it. Without stars, only the viewing will be saved.",
  "Выберите подходящий способ сохранения ниже.": "Choose the appropriate save option below.",
  "Оценка — при необходимости": "Rating — optional",
  "Только просмотр": "Viewing only",
  "Сохранит дату без оценки.": "Saves the date without a rating.",
  "Сохранит звёзды и выбранную дату.": "Saves the stars and selected date.",
  "Детальная оценка": "Detailed rating",
  "Откроет критерии и сохранит их с этой датой.": "Opens the criteria and saves them with this date.",
  "Как сохранить детальную оценку": "How to save a detailed rating",
  "Как оценить": "How to rate",
  "Поставьте звёзды только нужным критериям — остальные можно оставить пустыми. Затем нажмите «Сохранить оценки». Простая оценка фильма при этом не изменится.": "Rate only the criteria you need — the rest can stay empty. Then select ‘Save ratings’. The film's standard rating will not change.",
  "Как оценить эпизод или добавить пересмотр": "How to rate an episode or add a rewatch",
  "Оценить эпизод": "Rate an episode",
  "Нажмите «Оценить» справа от эпизода, затем выберите звёзды.": "Select ‘Rate’ next to the episode, then choose stars.",
  "Просмотр и пересмотр": "Viewing and rewatch",
  "Кнопка истории справа сохраняет первый просмотр, повторные просмотры, даты и количество.": "The history button on the right saves the first viewing, repeat viewings, dates and total count.",
  "Выберите дату нового просмотра. Оценку можно оставить прежней или изменить звёздами ниже, затем нажмите «Сохранить».": "Choose the new viewing date. Keep the current rating or change it with the stars below, then select ‘Save’.",
  "Укажите общее количество просмотров. Уже сохранённые даты останутся, недостающие просмотры добавятся без даты.": "Enter the total number of viewings. Saved dates will remain and missing viewings will be added without a date.",
  "Здесь можно изменить дату отдельного просмотра или удалить только выбранную запись истории.": "Here you can change the date of a specific viewing or delete only the selected history entry.",
  "Карточка отправлена": "Card shared",
  "Ссылка скопирована": "Link copied",
  "Не удалось подготовить ссылку профиля": "Could not prepare the profile link",
  "Ссылка на достижение скопирована": "Achievement link copied",
  "Не удалось скопировать ссылку достижения. Попробуйте ещё раз.": "Could not copy the achievement link. Please try again.",
  "Ссылка на итоги скопирована": "Results link copied",
  "Не удалось скопировать ссылку итогов. Попробуйте ещё раз.": "Could not copy the results link. Please try again.",
  "Не удалось загрузить полученные подборки. Обновите страницу или откройте уведомление ещё раз.": "Could not load shared collections. Refresh the page or open the notification again.",
  "Подборка из уведомления не найдена. Попросите отправить её ещё раз.": "The collection from the notification was not found. Ask the sender to share it again.",
  "Не удалось открыть полученную подборку. Обновите страницу или попробуйте ещё раз.": "Could not open the shared collection. Refresh the page or try again.",
  "Картинка скопирована. Вставьте её в мессенджер через Ctrl+V.": "Image copied. Paste it into a messenger with Ctrl+V.",
  "PNG скачан. Отправьте его как обычную картинку.": "PNG downloaded. Send it as a regular image.",
  "Не удалось создать карточку. Попробуйте ещё раз.": "Could not create the card. Please try again.",
  "Киноитоги": "Movie results",
  "Без главного фильма": "No featured movie",
  "Разные жанры": "Various genres",
  "Киноман CineParagon": "CineParagon cinephile",
  "Новое достижение": "New achievement",
  "Новое достижение в кино-путешествии CineParagon.": "A new achievement in your CineParagon movie journey.",
  "Киноман": "Cinephile",
  "часов": "hours",
  "стран": "countries",
  "серия": "streak",
  "без серии": "no streak",
  "Испытания еще загружаются": "Challenges are still loading",
  "Испытания можно менять только в своем профиле": "Challenges can only be changed in your own profile",
  "Испытание уже активно": "The challenge is already active",
  "Испытание уже завершено": "The challenge is already completed",
  "Экспедиции ещё загружаются": "Expeditions are still loading",
  "Экспедицию можно выбрать только в своём профиле": "An expedition can only be selected in your own profile",
  "На этой неделе уже выбрана одна экспедиция": "An expedition has already been selected this week",
  "Экспедиция не найдена": "Expedition not found",
  "Эта экспедиция недоступна в текущей демо-неделе": "This expedition is unavailable in the current demo week",
  "Не удалось открыть состояние недели": "Could not load the weekly state",
  "Прогресс можно пересчитать только в своём профиле": "Progress can only be recalculated in your own profile",
  "Пересчёт уже выполняется": "Recalculation is already in progress",
  "Сначала выберите карту недели": "Select a weekly card first",
  "После выбора карты пока нет новых просмотров для пересчёта": "There are no new views to recalculate since selecting the card",
  "Не удалось обновить данные фильмов. Попробуйте ещё раз": "Could not update movie data. Please try again",
  "Не удалось пересчитать прогресс": "Could not recalculate progress",
  "Карты можно открывать только в своем профиле": "Cards can only be opened in your own profile",
  "Три карты уже выбраны. Остальные карты недели недоступны": "Three cards have already been selected. The remaining weekly cards are unavailable",
  "За неделю можно открыть только 5 карт": "Only 5 cards can be opened per week",
  "Карты можно выбирать только в своем профиле": "Cards can only be selected in your own profile",
  "Карта не найдена": "Card not found",
  "Сначала откройте карту": "Open the card first",
  "за неделю можно выбрать только 3 карты": "only 3 cards can be selected per week",
  "Начата легендарная карта": "Legendary card started",
  "Выполнить задание легендарной карты": "Complete a legendary card quest",
  "Выполнить 10 заданий легендарных карт": "Complete 10 legendary card quests",
  "Завершить недельную соло-экспедицию": "Complete a weekly solo expedition",
  "Завершить эпическую экспедицию": "Complete an epic expedition",
  "Выполнить 50 заданий легендарных карт": "Complete 50 legendary card quests",
  "Выполнить 100 заданий легендарных карт": "Complete 100 legendary card quests",
  "Завершить легендарную экспедицию": "Complete a legendary expedition",
  "до 80 минут": "up to 80 minutes",
  "80-100 минут": "80–100 minutes",
  "100-120 минут": "100–120 minutes",
  "120-150 минут": "120–150 minutes",
  "150+ минут": "150+ minutes",
  "Условие": "Condition",
  "Высоко оценённый фильм": "Highly rated movie",
  "Киноманское испытание в CineParagon.": "A cinephile challenge on CineParagon.",
  "Удалить фильм из списка?": "Remove movie from list?",
  "будет удалён из списка": "will be removed from the list",
  "будет удален из списка": "will be removed from the list",
  "Номер страницы списка фильмов": "Movie list page number",

  "Фильмы, после которых нужно помолчать": "Movies that leave you speechless",
  "Фильмы, где почти один актёр весь фильм": "Movies with almost one actor throughout",
  "Фильмы, где почти один актер весь фильм": "Movies with almost one actor throughout",
  "Фильмы, где реальность оказывается ложной": "Movies where reality turns out to be false",
  "Фильмы, снятые как один дубль": "Movies shot like a single take",
  "Фильмы-медитации": "Meditative movies",
  "Фильмы, где главный герой — не человек": "Movies where the main character is not human",
  "Фильмы с обратным хронологическим порядком": "Movies in reverse chronological order",
  "Фильмы в одном помещении": "Movies set in one room",
  "Фильмы, которые ощущаются как сон": "Movies that feel like a dream",
  "Фильмы, где время — главный герой": "Movies where time is the main character",
  "Фильмы, где злодей оказывается прав": "Movies where the villain is right",
  "Фильмы с лучшим неожиданным финалом": "Movies with the best twist endings",
  "Фильмы о путешествиях во времени": "Time travel movies",
  "Лучшие фильмы о выживании": "Best survival movies",
  "Фильмы, которые заставляют задуматься": "Thought-provoking movies",
  "Лучшие камерные фильмы": "Best chamber films",
  "Фильмы про искусственный интеллект": "Movies about artificial intelligence",
  "Фильмы, где невозможно доверять рассказчику": "Movies with unreliable narrators",
  "Лучшие фильмы про мошенников": "Best con-artist movies",
  "Лучшие фильмы о памяти": "Best movies about memory",
    "Фильмы, после которых хочется путешествовать": "Movies that make you want to travel",
  "Кино для дождливого вечера": "Movies for a rainy evening",
  "Фильмы, которые возвращают ощущение дома": "Movies that feel like home",
  "Зимняя изоляция и холод за окном": "Winter isolation and cold outside",
  "Истории, рассказанные через еду": "Stories told through food",
  "Журналистские расследования на экране": "Investigative journalism on screen",
  "Судебные драмы без права на паузу": "Courtroom dramas that demand attention",
  "Ограбления с идеальным планом": "Heists with a perfect plan",
  "Одиночество в открытом космосе": "Solitude in outer space",
  "Истории, где океан диктует правила": "Stories ruled by the ocean",
  "Фильмы, в которых поезд меняет всё": "Movies where a train changes everything",
  "Пустыня как отдельный персонаж": "The desert as a character",
  "Архитектура, которая управляет историей": "Architecture that shapes the story",
  "Одержимость, за которую приходится платить": "Obsession that comes at a price",
  "Неожиданная дружба, которая всё меняет": "Unexpected friendships that change everything",
  "Взросление без готовых ответов": "Coming of age without easy answers",
  "Честное кино о родительстве": "Honest movies about parenthood",
  "Политические триллеры о цене власти": "Political thrillers about the price of power",
  "Технологии, от которых становится не по себе": "Technology that gets under your skin",
  "Тёмный фольклор и древние обряды": "Dark folklore and ancient rituals",
  "Сильные фильмы, где почти не нужны слова": "Powerful movies that barely need words",
  "Художники и цена творчества": "Artists and the price of creation",
  "Танец как способ рассказать историю": "Dance as storytelling",
  "Большой город после полуночи": "The big city after midnight",
  "Дорожные истории без привычного маршрута": "Road stories off the familiar route",
  "Работа как поле битвы": "The workplace as a battlefield",
  "Расследования, основанные на реальных событиях": "Investigations based on true events",
  "Поиск себя и новая идентичность": "Searching for yourself and a new identity",
  "Моральные дилеммы без простого решения": "Moral dilemmas without easy answers",
  "Маленькие города с большими тайнами": "Small towns with big secrets",
  "Ансамблевое кино, где важен каждый герой": "Ensemble movies where every character matters",
  "Романтика со светлой грустью": "Bittersweet romance",
  "Как рождается музыка": "How music is made",
  "частично": "partly",

  "ваше пространство": "your space",
  "Личные подборки": "Personal collections",
  "Собирайте фильмы по настроению или поводу и отправляйте готовые списки друзьям.": "Collect movies by mood or occasion and send finished lists to friends.",
  "Новая подборка": "New collection",
  "Мои подборки": "My collections",
  "Мне поделились": "Shared with me",
  "Со мной поделились": "Shared with me",
  "С вами поделились подборкой": "A collection was shared with you",
  "Позже": "Later",
  "Открыть подборку": "Open collection",
  "Открываем...": "Opening...",
  "Название подборки": "Collection name",
  "Например, кино для дождливого вечера": "For example, movies for a rainy evening",
  "Описание (необязательно)": "Description (optional)",
  "Для какого настроения или компании этот список?": "What mood or company is this list for?",
  "Создать": "Create",
  "Отмена": "Cancel",
  "Загружаем подборки…": "Loading collections…",
  "Подборка создана.": "Collection created.",
  "Не удалось создать подборку.": "Could not create the collection.",
  "Удалить эту подборку?": "Delete this collection?",
  "Удалить полученную подборку": "Delete received collection",
  "Подборка будет удалена из вашего профиля. Это действие нельзя отменить.": "The collection will be removed from your profile. This action cannot be undone.",
  "Удаляем…": "Deleting…",
  "Подборка удалена.": "Collection deleted.",
  "Не удалось удалить подборку.": "Could not delete the collection.",
  "Добавить фильмы": "Add movies",
  "Поделиться": "Share",
  "Удалить подборку": "Delete collection",
  "В подборке пока нет фильмов. Нажмите «+», чтобы наполнить её.": "There are no movies here yet. Press “+” to fill the collection.",
  "Создайте первую личную подборку": "Create your first personal collection",
  "Добавьте фильмы через быстрый поиск, а затем отправьте список другу или другому пользователю.": "Add movies with quick search, then send the list to a friend or another user.",
  "Входящих подборок пока нет": "No incoming collections yet",
  "Когда друг или другой пользователь поделится списком, он останется здесь и появится в событиях.": "When a friend or another user shares a list, it will stay here and appear in notifications.",
  "От": "From",
  "Название фильма или сериала": "Movie or series title",
  "Ищем…": "Searching…",
  "Найти": "Find",
  "До 80 фильмов в одной подборке.": "Up to 80 movies in one collection.",
  "Добавлен": "Added",
  "Фильм добавлен в подборку.": "Movie added to the collection.",
  "Не удалось добавить фильм.": "Could not add the movie.",
  "Убрать из подборки": "Remove from collection",
  "Не удалось удалить фильм из подборки.": "Could not remove the movie from the collection.",
  "Не удалось выполнить поиск.": "Could not complete the search.",
  "Поделиться подборкой": "Share collection",
  "Имя, почта или UID пользователя": "User name, email, or UID",
  "Получатель увидит уведомление сразу или при следующем входе. Ему отправится копия текущей подборки.": "The recipient will see a notification now or on their next sign-in. They will receive a copy of the current collection.",
  "Отправить": "Send",
  "Подборка отправлена пользователю": "Collection sent to",
  "Не удалось отправить подборку.": "Could not send the collection.",
  "Пользователи не найдены.": "No users found.",
  "Добавьте друзей или найдите пользователя по имени, почте или UID.": "Add friends or find a user by name, email, or UID.",
  "Откройте подборку, чтобы посмотреть фильмы.": "Open the collection to see the movies.",
  "поделился подборкой": "shared the collection",
  "Личная подборка": "Personal collection",

  "Платиновая звезда": "Platinum Star",
  "Золотая пальмовая ветвь": "Golden Palm",
  "Серебряная кинолента": "Silver Filmstrip",
  "Бронзовая звезда": "Bronze Star",
  "Начинающий киноман": "Beginner Cinephile",
  "Новичок": "Newcomer",
  "Образцовый киноман": "Model Cinephile",

  "Первое знакомство": "First acquaintance",
  "Мягкий старт": "Soft start",
  "Один шаг за карту": "One step for the map",
  "Кино без спешки": "Unhurried cinema",
  "Хорошее начало": "Good start",
  "Лёгкий смешок": "Light laugh",
  "Легкий смешок": "Light laugh",
  "Драматическая пауза": "Dramatic pause",
  "Штамп Азии": "Stamp of Asia",
  "Классическое касание": "Classic touch",
  "Современный штрих": "Modern touch",
  "Длинный вечер": "Long evening",
  "Чистый кинозал": "Pure cinema hall",
  "Кинонеделя": "Cinema week",
  "Стабильный зритель": "Steady viewer",
  "Жанровая разведка": "Genre scout",
  "Малое путешествие": "Small journey",
  "Европейские каникулы": "European holiday",
  "Восточный экспресс": "Eastern express",
  "Комедийная терапия": "Comedy therapy",
  "Неделя страха": "Fear week",
  "Ученик мастера": "Master's student",
  "Машина времени": "Time machine",
  "Фан-клуб": "Fan club",
  "За пределами Голливуда": "Beyond Hollywood",
  "Драматическая линия": "Dramatic line",
  "Уголок анимации": "Animation corner",
  "Семейный вечер": "Family evening",
  "Документальное окно": "Documentary window",
  "Маршрут фантастики": "Sci-fi route",
  "Криминальное дело": "Crime case",
  "Полка высоких оценок": "High-score shelf",
  "Три языка": "Three languages",
  "Музыкальная тема": "Musical theme",
  "Пробник классики": "Classic sampler",
  "Новое тысячелетие": "New millennium",
  "Серийная проба": "Series trial",
  "Французская открытка": "French postcard",
  "Корейский сигнал": "Korean signal",
  "Жанровый треугольник": "Genre triangle",
  "Почти без выходных": "Almost no weekends",
  "Месяц кино": "Cinema month",
  "Быстрые пятнадцать": "Fast fifteen",
  "Триллерный марафон": "Thriller marathon",
  "Мастер жанра": "Genre master",
  "Вокруг света": "Around the world",
  "Латиноамериканская экспедиция": "Latin American expedition",
  "Погружение": "Immersion",
  "Свидетель века": "Witness of the century",
  "Карьера под микроскопом": "Career under the microscope",
  "Ни одного повтора": "No repeats",
  "Кинотур по Европе": "Cinema tour of Europe",
  "Кинотур по Азии": "Cinema tour of Asia",
  "Африканские открытки": "African postcards",
  "Североамериканский маршрут": "North American route",
  "Композиторский марафон": "Composer marathon",
  "Авторская неделя": "Auteur week",
  "Актёрская серия": "Actor streak",
  "Актерская серия": "Actor streak",
  "Девятки на полке": "Nines on the shelf",
  "Погружение в классику": "Dive into classics",
  "Флэшбек семидесятых": "Seventies flashback",
  "Архив XXI века": "21st-century archive",
  "Сезон сериалов": "Series season",
  "Только кино": "Movies only",
  "Японская тропа": "Japanese path",
  "Архив любимого": "Favorites archive",
  "Полка девяток": "Shelf of nines",
  "Полка десяток": "Shelf of tens",
  "Жанровый пятиугольник": "Genre pentagon",
  "Сезон киномана": "Cinephile season",
  "Жизнь и творчество": "Life and work",
  "Покоритель континента": "Continent conqueror",
  "Гражданин мира": "Citizen of the world",
  "Свидетель эпох": "Witness of eras",
  "Одержимость": "Obsession",
  "Год за годом": "Year by year",
  "Киноархив": "Film archive",
  "Кинозапой": "Movie binge",
  "След немого кино": "Silent-era trail",
  "Золотой век": "Golden age",
  "Большой XXI век": "Big 21st century",
  "Пробник мира": "World sampler",
  "Кинополиглот": "Cinema polyglot",
  "Верность композитору": "Composer devotion",
  "Режиссёрская ретроспектива": "Director retrospective",
  "Режиссерская ретроспектива": "Director retrospective",
  "Актёрская легенда": "Actor legend",
  "Актерская легенда": "Actor legend",
  "Коллекционер жанров": "Genre collector",
  "Южный крест": "Southern Cross",
  "Глубокая Африка": "Deep Africa",
  "Сезон без США": "Season without the USA",
  "Путь куратора": "Curator's path",
  "Ни дня без фильма": "Not a day without a movie",
  "Два фильма в день": "Two movies a day",
  "Глобальная экспедиция": "Global expedition",
  "Абсолютный марафон": "Absolute marathon",
  "Живая энциклопедия": "Living encyclopedia",
  "Большой тур по годам": "Grand tour by year",
  "Мир без границ": "World without borders",
  "Жанровый всеядный": "Genre omnivore",
  "Марафон века": "Century marathon",
  "Большая карта мира": "Big world map",
  "Три фильма в день": "Three movies a day",
  "365 дней кино": "365 days of cinema",
  "130 лет кино": "130 years of cinema",
  "Киновселенная": "Cinema universe",
  "Кинотитан": "Cinema titan",
  "Жизнь с автором": "Life with an auteur",
  "Жизнь с актёром": "Life with an actor",
  "Жизнь с актером": "Life with an actor",
  "Симфония длиною в год": "Year-long symphony",
  "Атлас языков": "Atlas of languages",
  "Кинобессмертный": "Cinema immortal",
  "Почти весь мир": "Almost the whole world",
  "Интерстеллар": "Interstellar",
  "Матрица": "The Matrix",
  "Паразиты": "Parasite",
  "Амели": "Amélie",
  "Унесённые призраками": "Spirited Away",
  "Унесенные призраками": "Spirited Away",
  "Начало": "Inception",
  "Криминальное чтиво": "Pulp Fiction",
  "Форрест Гамп": "Forrest Gump",
  "Бойцовский клуб": "Fight Club",
  "Тёмный рыцарь": "The Dark Knight",
  "Темный рыцарь": "The Dark Knight",
  "Побег из Шоушенка": "The Shawshank Redemption",
  "Ковбой Бибоп: Достучаться до небес": "Cowboy Bebop: The Movie",
  "Письмо для Момо": "A Letter to Momo",
  "Мы купили птицеферму": "We Bought a Zoo",
  "Мы купили зоопарк": "We Bought a Zoo",
  "Секрет": "Secret",
  "Черное зеркало": "Black Mirror",
  "Чёрное зеркало": "Black Mirror",
  "Твоё имя": "Your Name.",
  "Твое имя": "Your Name.",
  "5 сантиметров в секунду": "5 Centimeters per Second",
  "Мультивселенная": "Multiverse",
  "Шинко С Вихром И Тысячелетняя Магия": "Mai Mai Miracle",
  "Шинко с Вихром и Тысячелетняя Магия": "Mai Mai Miracle",
  "Марджори Прайм": "Marjorie Prime",
  "Служанка": "The Handmaiden",
  "День сурка": "Groundhog Day",
  "Славные парни": "GoodFellas",
  "Остров проклятых": "Shutter Island",
  "Моя собака Идиот": "My Dog Stupid",
  "Жажда": "Thirst",
  "Последняя дуэль": "The Last Duel",
  "Сожги все мои письма": "Burn All My Letters",
  "Дедушка под прикрытием": "Undercover Grandpa",
  "После жизни": "After Life",
  "Вуди Вудпеккер": "Woody Woodpecker",
  "10.5 баллов": "10.5",
  "Доктор": "Doctor",
  "Свет": "Light",
  "Tokyo 7th シスターズ -僕らは青空になる-": "Tokyo 7th Sisters: We Are the Blue Sky",
  "雨上がりのスカイツリー": "After the Rain Skytree",
  "Только для влюбленных": "Only for Lovers",
  "Только для влюблённых": "Only for Lovers",
  "Двойная жизнь Вероники": "The Double Life of Véronique",
  "La leggenda del pianista sull'oceano": "The Legend of 1900",
  "Крёстный отец": "The Godfather",
  "Крестный отец": "The Godfather",
  "Джон Уик 4": "John Wick: Chapter 4",
  "Коко до Шанель": "Coco Before Chanel",
  "Апгрейд": "Upgrade",
  "Ангрейд": "Upgrade",
  "Грань будущего": "Edge of Tomorrow",
  "Области тьмы": "Limitless",
  "Девять дней": "Nine Days",
  "Цветы для Элджернона": "Flowers for Algernon",
  "Джонни Д.": "Public Enemies",
  "Алиса в стране чудес": "Alice in Wonderland",
  "Превосходство": "Transcendence",
  "Тайное окно": "Secret Window",
  "Что гложет Гилберта Грейпа?": "What's Eating Gilbert Grape",
  "Первый мститель: Другая война": "Captain America: The Winter Soldier",
  "Железный человек 2": "Iron Man 2",
  "Три икса 2: Новый уровень": "xXx: State of the Union",
  "Первый мститель": "Captain America: The First Avenger",
  "Звёздные войны: Эпизод 2 - Атака клонов": "Star Wars: Episode II - Attack of the Clones",
  "Звездные войны: Эпизод 2 - Атака клонов": "Star Wars: Episode II - Attack of the Clones",
  "28 лет спустя": "28 Years Later",
  "Крысолов": "The Rat Catcher",
  "Лебедь": "The Swan",
  "Отель «Гранд Будапешт»": "The Grand Budapest Hotel",
  "Отель \"Гранд Будапешт\"": "The Grand Budapest Hotel",
  "Яд": "Venom",
  "Хоббит: Битва пяти воинств": "The Hobbit: The Battle of the Five Armies",
  "Супруги Роуз": "The Roses",
  "Пятая власть": "The Fifth Estate",
  "Шерлок": "Sherlock",
  "Вавилон": "Babylon",
  "Одиннадцать друзей Оушена": "Ocean's Eleven",
  "Бесславные ублюдки": "Inglourious Basterds",
  "Ярость": "Fury",
  "Знакомьтесь, Джо Блэк": "Meet Joe Black",
  "Дневник баскетболиста": "The Basketball Diaries",
  "Битва за битвой": "One Battle After Another",
  "Волк с Уолл-стрит": "The Wolf of Wall Street",
  "Отступники": "The Departed",
  "Настоящая боль": "A Real Pain",
  "Двойник": "The Double",
  "Громче, чем бомбы": "Louder Than Bombs",
  "Добро пожаловать в Zомбилэнд": "Zombieland",
  "Добро пожаловать в Зомбилэнд": "Zombieland",
  "Конец тура": "The End of the Tour",
  "кристофер нолан": "Christopher Nolan",
  "Кристофер Нолан": "Christopher Nolan",
  "мэттью макконахи": "Matthew McConaughey",
  "Мэттью Макконахи": "Matthew McConaughey",
  "ханс циммер": "Hans Zimmer",
  "Ханс Циммер": "Hans Zimmer",
  "лана вачовски": "Lana Wachowski",
  "Лана Вачовски": "Lana Wachowski",
  "киану ривз": "Keanu Reeves",
  "Киану Ривз": "Keanu Reeves",
  "дон дэвис": "Don Davis",
  "Дон Дэвис": "Don Davis",
  "пон джун-хо": "Bong Joon-ho",
  "Пон Джун-хо": "Bong Joon-ho",
  "сон кан-хо": "Song Kang-ho",
  "Сон Кан-хо": "Song Kang-ho",
  "сон ган-хо": "Song Kang-ho",
  "сон ган хо": "Song Kang-ho",
  "чон джэ-иль": "Jung Jae-il",
  "Чон Джэ-иль": "Jung Jae-il",
  "жан-пьер жене": "Jean-Pierre Jeunet",
  "Жан-Пьер Жене": "Jean-Pierre Jeunet",
  "одри тоту": "Audrey Tautou",
  "Одри Тоту": "Audrey Tautou",
  "янн тирсен": "Yann Tiersen",
  "Янн Тирсен": "Yann Tiersen",
  "хаяо миядзаки": "Hayao Miyazaki",
  "Хаяо Миядзаки": "Hayao Miyazaki",
  "руми хиираги": "Rumi Hiiragi",
  "Руми Хиираги": "Rumi Hiiragi",
  "Карэн Мияма": "Karen Miyama",
  "Тосиюки Нисида": "Toshiyuki Nishida",
  "Джузеппе Торнаторе": "Giuseppe Tornatore",
  "Коити Ямадэра": "Koichi Yamadera",
  "Коити Ямадера": "Koichi Yamadera",
  "Коичи Ямадэра": "Koichi Yamadera",
  "Коичи Ямадера": "Koichi Yamadera",
  "Коиту Ямадэра": "Koichi Yamadera",
  "Синъитиро Ватанабэ": "Shinichiro Watanabe",
  "Синъитиро Ватанабе": "Shinichiro Watanabe",
  "Унсё Исидзука": "Unsho Ishizuka",
  "Унсе Исидзука": "Unsho Ishizuka",
  "優希": "Yuki",
  "дзё хисаиси": "Joe Hisaishi",
  "Дзё Хисаиси": "Joe Hisaishi",
  "дзо хисаиси": "Joe Hisaishi",
  "Дзо Хисаиси": "Joe Hisaishi",
  "леонардо дикаприо": "Leonardo DiCaprio",
  "Леонардо ДиКаприо": "Leonardo DiCaprio",
  "квентин тарантино": "Quentin Tarantino",
  "Квентин Тарантино": "Quentin Tarantino",
  "джон траволта": "John Travolta",
  "Джон Траволта": "John Travolta",
  "роберт земекис": "Robert Zemeckis",
  "Роберт Земекис": "Robert Zemeckis",
  "том хэнкс": "Tom Hanks",
  "Том Хэнкс": "Tom Hanks",
  "дэвид финчер": "David Fincher",
  "Дэвид Финчер": "David Fincher",
  "брэд питт": "Brad Pitt",
  "Брэд Питт": "Brad Pitt",
  "джонни депп": "Johnny Depp",
  "Джонни Депп": "Johnny Depp",
  "сэмюэл л. джексон": "Samuel L. Jackson",
  "Сэмюэл Л. Джексон": "Samuel L. Jackson",
  "рэйф файнс": "Ralph Fiennes",
  "Рэйф Файнс": "Ralph Fiennes",
  "бенедикт камбербэтч": "Benedict Cumberbatch",
  "Бенедикт Камбербэтч": "Benedict Cumberbatch",
  "бенедикт камбербетч": "Benedict Cumberbatch",
  "Бенедикт Камбербетч": "Benedict Cumberbatch",
  "скарлетт йоханссон": "Scarlett Johansson",
  "Скарлетт Йоханссон": "Scarlett Johansson",
  "джесси айзенберг": "Jesse Eisenberg",
  "Джесси Айзенберг": "Jesse Eisenberg",
  "кристиан бейл": "Christian Bale",
  "Кристиан Бейл": "Christian Bale",
  "фрэнк дарабонт": "Frank Darabont",
  "Фрэнк Дарабонт": "Frank Darabont",
  "тим роббинс": "Tim Robbins",
  "Тим Роббинс": "Tim Robbins",
  "фрэнсис форд коппола": "Francis Ford Coppola",
  "Фрэнсис Форд Коппола": "Francis Ford Coppola",
  "марлон брандо": "Marlon Brando",
  "Марлон Брандо": "Marlon Brando",
  "чад стахелски": "Chad Stahelski",
  "Чад Стахелски": "Chad Stahelski",
  "Лимит испытаний": "Challenge limit",
  "Выбрано максимально допустимое количество испытаний. Чтобы выбрать новое испытание, откажитесь от одного из уже выбранных.": "You have selected the maximum number of challenges. To choose a new one, abandon one of the active challenges.",
  "Понятно": "Got it",
  "Запускать испытания можно только в своем профиле.": "Challenges can only be started from your own profile.",
  "Начать испытание": "Start challenge",
  "Попробовать снова": "Try again",
  "Отказаться": "Abandon",
  "Срок истек": "Expired",
  "Время вышло": "Time is up",
  "Выбрать первое": "Choose first",
  "испытание": "challenge",
  "Добавить испытание": "Add challenge",
  "Развернуть испытания": "Expand challenges",
  "Свернуть испытания": "Collapse challenges",
  "Загрузка испытаний": "Loading challenges",
  "Загрузка испытаний...": "Loading challenges...",

  "Легендарная карта": "Legendary card",
  "Охотник за легендами": "Legend hunter",
  "Первая экспердиция": "First expedition",
  "Первая экспедиция": "First expedition",
  "Эпический рейд": "Epic raid",
  "Награда получена": "Reward received",
  "Награда не получена": "Reward not received",
  "Пересчитано качество недели": "Week quality recalculated",
  "1 фильм за неделю": "1 movie in a week",
  "3 фильма за неделю": "3 movies in a week",
  "Коллекционер легенд": "Legend collector",
  "Повелитель легендарных карт": "Lord of legendary cards",
  "Легендарный рейд": "Legendary raid",
  "Первая золотая неделя": "First gold week",
  "Первая платиновая неделя": "First platinum week",
  "Первая алмазная неделя": "First diamond week",
  "Первая легендарная неделя": "First legendary week",
  "10 золотых недель": "10 gold weeks",
  "10 платиновых недель": "10 platinum weeks",
  "10 алмазных недель": "10 diamond weeks",
  "10 легендарных недель": "10 legendary weeks",
  "7 фильмов за неделю": "7 movies in a week",
  "14 фильмов за неделю": "14 movies in a week",
  "21 фильм за неделю": "21 movies in a week",
  "28 фильмов за неделю": "28 movies in a week",

  "Путешественник во времени": "Time traveler",
  "Десятилетия и история кино": "Decades and film history",
  "Жанровая лаборатория": "Genre laboratory",
  "Базовые жанры": "Basic genres",
  "Кинопочта мира": "World cine-mail",
  "Классический маршрут": "Classic route",
  "Классика XX века": "20th-century classics",
  "Ворота Азии": "Gates of Asia",
  "Азиатское кино": "Asian cinema",
  "Новый Голливуд": "New Hollywood",
  "Американское кино": "American cinema",
  "Корейский нерв": "Korean nerve",
  "Корейские триллеры": "Korean thrillers",
  "Космическая одиссея": "Space odyssey",
  "Космос и фантастика": "Space and science fiction",
  "Европейское полотно": "European canvas",
  "Европейское кино": "European cinema",
  "Обряд анимации": "Animation rite",
  "Анимация": "Animation",
  "Врата века": "Century gate",
  "Классика и современность": "Classics and modernity",
  "Корона мирового кино": "Crown of world cinema",
  "Глобальный кинематограф": "Global cinema",
  "Корона жанров": "Crown of genres",
  "Жанровый марафон": "Genre marathon",
  "Финальный этап": "Final stage",
  "Финальный": "Final",

  "Фильм:": "Movie:",
  "режиссёр": "director",
  "режиссер": "director",
  "актёр": "actor",
  "актер": "actor",
  "композитор": "composer",
  "2010-е": "2010s",
  "2000-е": "2000s",
  "1990-е": "1990s",
  "1980-е": "1980s",
  "1970-е": "1970s",
  "1960-е": "1960s",
  "1950-е": "1950s",
  "Япония": "Japan",
  "Франция": "France",
  "Европа": "Europe",
  "Азия": "Asia",
  "Южная Корея": "South Korea",
  "Азии": "Asia",
  "Европы": "Europe",
  "Африки": "Africa",
  "Океании": "Oceania",
  "Северной Америки": "North America",
  "Южной Америки": "South America",
  "Франции": "France",
  "Японии": "Japan",
  "Южной Кореи": "South Korea",
  "США": "USA",
  "любой страны": "any country",
  "после 2010 года": "after 2010",
  "после 1980 года": "after 1980",
  "после 2000 года": "after 2000",
  "до 1970 года": "before 1970",
  "до 1980 года": "before 1980",
  "до 1940 года": "before 1940",
  "до 2000 года": "before 2000",
  "США до 1980 года": "from the USA before 1980",
  "США 1980-2000 годов": "from the USA, 1980–2000",
  "США после 2000 года": "from the USA after 2000",
  "за месяц": "in a month",
  "от 150 минут": "of at least 150 minutes",
  "2000-х и новее": "from the 2000s or newer",
  "1970-х": "from the 1970s",
  "1940-1979 годов": "from 1940–1979",
  "1920-1950 годов": "from 1920–1950",
  "1951-1980 годов": "from 1951–1980",
  "1981-2026 годов": "from 1981–2026",
  "1970-1999 годов": "from 1970–1999",
  "2000-2026 годов": "from 2000–2026",
  "1950-х": "from the 1950s",
  "1960-х": "from the 1960s",
  "европейских": "European",
  "азиатских": "Asian",
  "южнокорейских": "South Korean",
  "фантастических": "science fiction",
  "драму": "drama",
  "комедию": "comedy",
  "триллера": "thrillers",
  "триллеров": "thrillers",
  "хоррора": "horror movies",
  "хорроров": "horror movies",
  "драм": "dramas",
  "комедии": "comedies",
  "комедий": "comedies",
  "мультфильма": "animated movies",
  "мультфильмов": "animated movies",
  "семейных": "family",
  "документальных": "documentary",
  "криминальных или детективных": "crime or mystery",
  "базовых жанров": "from basic genres",
  "полнометражных": "feature",
  "золотых": "gold",
  "платиновых": "platinum",
  "алмазных": "diamond",
  "легендарных": "legendary"
});

Object.assign(UI_TRANSLATIONS.en, {
  "Обзор": "Overview",
  "Вкус": "Taste",
  "Разделы статистики": "Statistics sections",
  "Медиана": "Median",
  "Наиболее частая оценка": "Most frequent rating",
  "Количество оценок": "Ratings count",
  "Активных недель": "Active weeks",
  "Подробнее": "View details",
  "История просмотров": "Viewing history",
  "Личная киноистория": "Personal viewing history",
  "Посмотрел ещё раз": "Watched again",
  "Отметить повторный просмотр": "Add another viewing",
  "Добавить просмотр": "Add viewing",
  "Указать количество просмотров": "Set viewing count",
  "Текущая основная оценка": "Current main rating",
  "Текущая оценка сезона": "Current season rating",
  "Оценка изменится отдельно и не создаст новую первую оценку.": "The rating is changed separately and will not create another first rating.",
  "Оценка сезона изменится отдельно и не создаст новую первую оценку.": "The season rating is changed separately and will not create another first rating.",
  "Общее количество просмотров": "Total viewings",
  "Известные даты сохранятся, а недостающие просмотры будут добавлены без даты.": "Known dates will be kept and missing viewings will be added without dates.",
  "Количество не может быть меньше уже сохранённой истории.": "The count cannot be lower than the saved history.",
  "Не удалось сохранить просмотр.": "Could not save the viewing.",
  "Не удалось обновить количество просмотров.": "Could not update the viewing count.",
  "Не удалось изменить запись просмотра.": "Could not update the viewing entry.",
  "Не удалось удалить запись просмотра.": "Could not delete the viewing entry.",
  "Это последняя запись просмотра. Основная оценка сохранится. Удалить запись?": "This is the last viewing entry. The main rating will be kept. Delete the entry?",
  "Удалить эту запись просмотра?": "Delete this viewing entry?",
  "В истории пока нет записей. Основная оценка сохранена отдельно.": "There are no viewing entries yet. The main rating is stored separately.",
  "Изменить дату просмотра": "Change viewing date",
  "Удалить запись просмотра": "Delete viewing entry",
  "Нет сохранённых просмотров": "No saved viewings",
  "Последний просмотр": "Last viewed",
  "Даты не указаны": "Dates not specified",
  "Основная оценка сохранена отдельно.": "The main rating is stored separately.",
  "Статистика пересмотров": "Rewatch statistics",
  "Загрузка статистики просмотров...": "Loading viewing statistics...",
  "просмотров всего": "total viewings",
  "просмотров": "viewings",
  "просмотр": "viewing",
  "уникальных произведений": "unique titles",
  "пересмотров": "rewatches",
  "доля пересмотров": "rewatch share",
  "Просмотрено больше одного раза": "Viewed more than once",
  "Самые пересматриваемые": "Most rewatched",
  "Уникальных произведений": "Unique titles",
  "Первые просмотры": "First viewings",
  "Всего просмотров": "Total viewings",
  "Самый пересматриваемый фильм": "Most rewatched movie",
  "Фильтры истории просмотров": "Viewing history filters",
  "Показывать": "Show",
  "Все просмотренные": "All watched",
  "Просмотрено один раз": "Watched once",
  "Пересмотрено": "Rewatched",
  "Просмотрено 3 раза и более": "Watched 3 or more times",
  "Недавно пересмотрено": "Recently rewatched",
  "Сортировка": "Sort",
  "По дате добавления": "By date added",
  "По количеству просмотров": "By viewing count",
  "По дате последнего просмотра": "By last viewing date",
  "По дате первого известного просмотра": "By first known viewing date",
  "Ещё раз": "Again",
  "Просмотр": "Viewing",
  "История": "History",
  "Количество": "Count",
  "Оценка": "Rating",
  "Не удалось сохранить настройку приватности. Попробуйте ещё раз.": "Could not save the privacy setting. Please try again.",
  "Не удалось загрузить профиль. Попробуйте обновить страницу.": "Could not load the profile. Please refresh the page.",
  "Поиск пользователей временно недоступен. Попробуйте ещё раз.": "User search is temporarily unavailable. Please try again.",
  "Экспедиции недели ещё не готовы": "This week's expeditions are not ready yet",
  "Эта экспедиция недоступна на этой неделе": "This expedition is unavailable this week",
  "Началась новая неделя. Обновите страницу и выберите новую экспедицию.": "A new week has started. Refresh the page and choose a new expedition.",
  "Текущая неделя уже завершилась. Обновите страницу.": "The current week has already ended. Refresh the page.",
  "Не удалось создать состояние текущей недели": "Could not create the current week's state",
  "без награды": "no reward",
  "Актёр": "Actor",
  "Актриса": "Actress",
  "Композитор": "Composer",
  "Режиссёр": "Director",
  "Монтажёр": "Editor",
  "Исполнительный продюсер": "Executive Producer",
  "Продюсер": "Producer",
  "В роли себя": "Self",
  "Оператор-постановщик": "Director of Photography",
  "Сценарист": "Writer",
  "Автор сюжета": "Story",
  "Загрузка раздела…": "Loading section...",
  "Загрузка игровых заданий...": "Loading game challenges..."
});

const PLURAL_WORDS: Record<string, string> = {
  фильм: "movie",
  фильма: "movies",
  фильмов: "movies",
  минута: "minute",
  минуты: "minutes",
  минут: "minutes",
  список: "list",
  списка: "lists",
  списков: "lists"
};

const normalizeLookupKey = (value: unknown) =>
  String(value || "")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLocaleLowerCase("ru-RU")
    .replace(/ё/g, "е");

const UI_TRANSLATIONS_EN_LOWER = Object.fromEntries(
  Object.entries(UI_TRANSLATIONS.en).map(([key, translation]) => [
    normalizeLookupKey(key),
    translation
  ])
);

const KNOWN_TERMS: Record<string, string> = {
  "нф и фэнтези": "Sci-Fi & Fantasy",
  "научная фантастика и фэнтези": "Sci-Fi & Fantasy",
  "фантастика": "Science Fiction",
  "драма": "Drama",
  "детектив": "Mystery",
  "мультфильм": "Animation",
  "мелодрама": "Romance",
  "семейный": "Family",
  "фэнтези": "Fantasy",
  "комедия": "Comedy",
  "боевик": "Action",
  "боевик и приключения": "Action & Adventure",
  "триллер": "Thriller",
  "документальный": "Documentary",
  "документа...": "Documentary",
  "детский": "Kids",
  "история": "History",
  "военный": "War",
  "война и политика": "War & Politics",
  "музыка": "Music",
  "ужасы": "Horror",
  "криминал": "Crime",
  "приключения": "Adventure",
  "вестерн": "Western",
  "новости": "News",
  "мыльная опера": "Soap",
  "телевизионный фильм": "TV Movie",
  "ток-шоу": "Talk",
  "реалити": "Reality",
  "реалити-шоу": "Reality",
  "сша": "USA",
  "великобритания": "United Kingdom",
  "япония": "Japan",
  "франция": "France",
  "германия": "Germany",
  "канада": "Canada",
  "индия": "India",
  "кнр": "China",
  "кнр (китай)": "China",
  "кнр (китайская народная республика)": "China",
  "китай": "China",
  "южная корея": "South Korea",
  "республика корея": "South Korea",
  "испания": "Spain",
  "италия": "Italy",
  "ирландия": "Ireland",
  "австралия": "Australia",
  "новая зеландия": "New Zealand",
  "польша": "Poland",
  "норвегия": "Norway",
  "нидерланды": "Netherlands",
  "россия": "Russia",
  "российская федерация": "Russia",
  "ссср": "USSR",
  "украина": "Ukraine",
  "швеция": "Sweden",
  "дания": "Denmark",
  "словения": "Slovenia",
  "австрия": "Austria",
  "израиль": "Israel",
  "гонконг": "Hong Kong",
  "бразилия": "Brazil",
  "мексика": "Mexico",
  "иран": "Iran",
  "аргентина": "Argentina",
  "югославия": "Yugoslavia"
};

const translateKnownTerm = (value: string): string =>
  KNOWN_TERMS[normalizeLookupKey(value)] || UI_TRANSLATIONS_EN_LOWER[normalizeLookupKey(value)] || value;

const translateKnownTermList = (value: string): string => {
  const normalized = String(value || "").replace(/\s+/g, " ").trim();
  if (!normalized) return "";
  const separators = normalized.match(/\s*[·,;/]\s*|\s+/g) || [];
  const parts = normalized.split(/\s*[·,;/]\s*|\s+/).filter(Boolean);
  if (!parts.length) return "";
  const translatedParts = parts.map((part) => KNOWN_TERMS[normalizeLookupKey(part)]);
  if (translatedParts.some((part) => !part)) return "";
  return parts.reduce((result, _part, index) => {
    const separator = separators[index - 1] || "";
    const normalizedSeparator = separator.includes("·")
      ? " · "
      : separator.includes(",")
        ? ", "
        : separator.includes(";")
          ? "; "
          : " ";
    return `${result}${index === 0 ? "" : normalizedSeparator}${translatedParts[index]}`;
  }, "");
};

// Старые события, испытания и экспедиции уже могут быть сохранены в
// пользовательских данных. Нормализуем их при показе, не переписывая
// документы задним числом.
const LEGACY_UI_TEXT_REPLACEMENTS: Record<string, string> = {
  "Провалена": "Не пройдена",
  "Экспедиция провалена": "Экспедиция не пройдена",
  "Провалена: удалена зачтённая оценка": "Не пройдена: удалена зачтённая оценка",
  "Провалена: удалена зачтенная оценка": "Не пройдена: удалена зачтенная оценка",
  "Закрыть 5 базовых жанров":
    "Посмотреть фильмы пяти жанров: драма, комедия, триллер, фантастика и мультфильм",
  "Посмотрите 12 фильмов базовых жанров.":
    "Посмотрите 12 фильмов жанров: драма, комедия, фантастика или мультфильм."
};

export function translateTextValue(value: string, language?: string): string;
export function translateTextValue<T>(value: T, language?: string): T | string;
export function translateTextValue(value: unknown, language = "ru"): unknown {
  if (value == null) return value;
  const sourceText = String(value);
  const sourceLeading = sourceText.match(/^\s*/)?.[0] || "";
  const sourceTrailing = sourceText.match(/\s*$/)?.[0] || "";
  const sourceNormalized = sourceText.replace(/\s+/g, " ").trim();
  const legacyReplacement = LEGACY_UI_TEXT_REPLACEMENTS[sourceNormalized];

  if (language !== "en") {
    return legacyReplacement
      ? `${sourceLeading}${legacyReplacement}${sourceTrailing}`
      : value;
  }

  const text = legacyReplacement
    ? `${sourceLeading}${legacyReplacement}${sourceTrailing}`
    : sourceText;
  const leading = text.match(/^\s*/)?.[0] || "";
  const trailing = text.match(/\s*$/)?.[0] || "";
  const normalized = text.replace(/\s+/g, " ").trim();
  if (!normalized) return value;

  const exact = UI_TRANSLATIONS.en[normalized];
  if (exact) return `${leading}${exact}${trailing}`;
  const lowerExact = UI_TRANSLATIONS_EN_LOWER[normalizeLookupKey(normalized)];
  if (lowerExact) return `${leading}${lowerExact}${trailing}`;
  const knownTerm = KNOWN_TERMS[normalizeLookupKey(normalized)];
  if (knownTerm) return `${leading}${knownTerm}${trailing}`;

  const knownTermList = translateKnownTermList(normalized);
  if (knownTermList) return `${leading}${knownTermList}${trailing}`;

  const terminalSentencePunctuation = normalized.match(/^(.+?)([.!?])$/);
  if (terminalSentencePunctuation && !/[.!?]{2,}$/.test(normalized)) {
    const translatedWithoutPunctuation = translateTextValue(terminalSentencePunctuation[1], language);
    if (translatedWithoutPunctuation !== terminalSentencePunctuation[1]) {
      return `${leading}${translatedWithoutPunctuation}${terminalSentencePunctuation[2]}${trailing}`;
    }
  }

  if (/\s+(?:·|\+)\s+/.test(normalized)) {
    const parts = normalized.split(/(\s+(?:·|\+)\s+)/);
    const translatedParts = parts.map((part) =>
      /\s+(?:·|\+)\s+/.test(part) ? part : translateTextValue(part, language)
    );
    if (translatedParts.join("") !== normalized) {
      return `${leading}${translatedParts.join("")}${trailing}`;
    }
  }

  let match = normalized.match(/^(\d+(?:[.,]\d+)?)\s+(фильм|фильма|фильмов|минута|минуты|минут|список|списка|списков)$/i);
  if (match) {
    return `${leading}${match[1]} ${PLURAL_WORDS[match[2].toLowerCase()] || match[2]}${trailing}`;
  }

  match = normalized.match(/^(\d+)-(?:я|ая)\s+неделя\s+(\d{4})$/i);
  if (match) return `${leading}Week ${match[1]}, ${match[2]}${trailing}`;

  match = normalized.match(/^(\d+(?:[.,]\d+)?)\s+(неделя|недели|недель)$/i);
  if (match) return `${leading}${match[1]} ${Number(match[1]) === 1 ? "week" : "weeks"}${trailing}`;

  match = normalized.match(/^(\d+(?:[.,]\d+)?)\s+(оценка|оценки|оценок)$/i);
  if (match) return `${leading}${match[1]} ${Number(match[1]) === 1 ? "rating" : "ratings"}${trailing}`;

  match = normalized.match(/^Слайд\s+(\d+)\s+из\s+(\d+)$/i);
  if (match) return `${leading}Slide ${match[1]} of ${match[2]}${trailing}`;

  match = normalized.match(/^Перейти к слайду\s+(\d+)$/i);
  if (match) return `${leading}Go to slide ${match[1]}${trailing}`;

  match = normalized.match(/^Прогресс:?\s*(\d+)\s+из\s+(\d+)$/i);
  if (match) return `${leading}Progress: ${match[1]} of ${match[2]}${trailing}`;

  match = normalized.match(/^Поделиться:\s*(.+)$/i);
  if (match) return `${leading}Share: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Не удалось загрузить\s+(\d+)\s+из\s+(\d+)\s+сезонов\. Доступные сезоны можно оценить\.$/i);
  if (match) return `${leading}Could not load ${match[1]} of ${match[2]} seasons. Available seasons can still be rated.${trailing}`;

  match = normalized.match(/^Сезон\s+(\d+)$/i);
  if (match) return `${leading}Season ${match[1]}${trailing}`;

  match = normalized.match(/^Удалить пользователя\s+(.+)\s+из друзей\??$/i);
  if (match) {
    return `${leading}Remove ${translateTextValue(match[1], language)} from friends${normalized.endsWith("?") ? "?" : ""}${trailing}`;
  }

  match = normalized.match(/^Удалить\s+(.+)\s+из друзей$/i);
  if (match) return `${leading}Remove ${match[1]} from friends${trailing}`;

  match = normalized.match(/^До\s+(\d+)\s+фильмов\s+в\s+одной\s+подборке\.?$/i);
  if (match) return `${leading}Up to ${match[1]} movies in one collection${normalized.endsWith(".") ? "." : ""}${trailing}`;

  match = normalized.match(/^Одновременно можно выполнять только\s+(\d+)\s+испытаний$/i);
  if (match) return `${leading}Only ${match[1]} challenges can be active at a time${trailing}`;

  match = normalized.match(/^Пересмотрен фильм\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Movie rewatched: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Просмотр\s+№\s*(\d+)$/i);
  if (match) return `${leading}Viewing #${match[1]}${trailing}`;

  match = normalized.match(/^Обновлена история просмотров фильма\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Viewing history updated for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Указано:\s+просмотрено\s+(\d+)\s+раз$/i);
  if (match) return `${leading}Set to ${match[1]} ${Number(match[1]) === 1 ? "viewing" : "viewings"}${trailing}`;

  match = normalized.match(/^Пересмотрен сезон\s+[“"«](.+)[”"»]\s+сериала\s+[“"«](.+)[”"»]$/i);
  if (match) {
    return `${leading}Season “${translateTextValue(match[1], language)}” rewatched for “${translateTextValue(match[2], language)}”${trailing}`;
  }

  match = normalized.match(/^Обновлена история просмотров сезона\s+[“"«](.+)[”"»]\s+сериала\s+[“"«](.+)[”"»]$/i);
  if (match) {
    return `${leading}Viewing history updated for season “${translateTextValue(match[1], language)}” of “${translateTextValue(match[2], language)}”${trailing}`;
  }

  match = normalized.match(/^Обновлены данные\s+(\d+)\s+фильмов,\s+(\d+)\s+не удалось обновить$/i);
  if (match) return `${leading}Updated ${match[1]} movies; ${match[2]} could not be updated${trailing}`;

  match = normalized.match(/^Прогресс пересчитан по\s+(\d+)\s+фильмам$/i);
  if (match) return `${leading}Progress recalculated using ${match[1]} movies${trailing}`;

  match = normalized.match(/^Отозвано достижение:\s+(.+)$/i);
  if (match) return `${leading}Achievement revoked: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^После удаления оценки фильма\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}After deleting the rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Выполнена\s+(карта(?:\s+недели|:\s*.+))$/i);
  if (match) return `${leading}Completed: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Отозвана\s+(карта(?:\s+недели|:\s*.+))$/i);
  if (match) return `${leading}Revoked: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Испытание отозвано:\s+(.+)$/i);
  if (match) return `${leading}Challenge revoked: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Серия пересчитана:\s+(\d+)\s+нед\.?$/i);
  if (match) return `${leading}Streak recalculated: ${match[1]} ${Number(match[1]) === 1 ? "week" : "weeks"}${trailing}`;

  match = normalized.match(/^Серия (продлена|скорректирована):\s+(\d+)\s+(?:неделя|недели|недель|нед\.?)$/i);
  if (match) {
    const action = match[1].toLowerCase() === "продлена" ? "extended" : "adjusted";
    return `${leading}Streak ${action}: ${match[2]} ${Number(match[2]) === 1 ? "week" : "weeks"}${trailing}`;
  }

  match = normalized.match(/^Детальная оценка:\s+(.+)$/i);
  if (match) return `${leading}Detailed rating: ${match[1]}${trailing}`;

  match = normalized.match(/^Карта:\s+(.+)$/i);
  if (match) {
    const cardLabel = String(translateTextValue(match[1], language));
    return `${leading}Card: ${cardLabel.charAt(0).toUpperCase()}${cardLabel.slice(1)}${trailing}`;
  }

  match = normalized.match(/^Экспедиция:\s+(.+)$/i);
  if (match) return `${leading}Expedition: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^(.+?)\s+поделился(?:ась)?\s+подборкой\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}${match[1]} shared the collection “${translateTextValue(match[2], language)}”${trailing}`;

  match = normalized.match(/^Пересчитано качество недели:\s+(.+)$/i);
  if (match) return `${leading}Week quality recalculated: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^После изменения оценки фильма\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}After changing the rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^За импорт оценки фильма\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}For importing the rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^За удаление устаревшей импортированной оценки\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}For removing the outdated imported rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Оценок\s+(.+)$/i);
  if (match) return `${leading}Ratings of ${match[1]}${trailing}`;

  match = normalized.match(/^(\d+)\s+фильмов\s+и\s+сериалов\s+за\s+день$/i);
  if (match) return `${leading}${match[1]} movies and series in one day${trailing}`;

  match = normalized.match(/^(.+):\s+оценка\s+(.+)$/i);
  if (match) return `${leading}${match[1]}: rating ${match[2]}${trailing}`;

  match = normalized.match(/^(.+):\s+просмотрено без оценки$/i);
  if (match) return `${leading}${match[1]}: watched without a rating${trailing}`;

  match = normalized.match(/^Загружаем страницу\s+(\d+)$/i);
  if (match) return `${leading}Loading page ${match[1]}${trailing}`;

  match = normalized.match(/^(\d+)\s+г\.\s+(\d+)\s+мес\.$/i);
  if (match) return `${leading}${match[1]} y ${match[2]} mo${trailing}`;

  match = normalized.match(/^(\d+)\s+мес\.\s+(\d+)\s+дн\.$/i);
  if (match) return `${leading}${match[1]} mo ${match[2]} d${trailing}`;

  match = normalized.match(/^Ур\.\s*(.+)$/i);
  if (match) return `${leading}Lvl. ${match[1]}${trailing}`;

  match = normalized.match(/^(\d+)\s+тематическ(?:ий список|их списка|их списков)$/i);
  if (match) return `${leading}${match[1]} thematic ${Number(match[1]) === 1 ? "list" : "lists"}${trailing}`;

  match = normalized.match(/^обновлено\s+(.+)$/i);
  if (match) return `${leading}updated ${match[1]}${trailing}`;

  match = normalized.match(/^Экспедиция\s+выбрана[.!]?$/i);
  if (match) return `${leading}Expedition selected${trailing}`;

  match = normalized.match(/^Фильм:\s+(.+)$/i);
  if (match) return `${leading}Movie: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Фильм-источник:\s+(.+)$/i);
  if (match) return `${leading}Source movie: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Добавить\s+(.+)\s+в\s+буду смотреть$/i);
  if (match) return `${leading}Add ${match[1]} to watchlist${trailing}`;

  match = normalized.match(/^Скрыть рекомендацию\s+(.+)$/i);
  if (match) return `${leading}Hide recommendation ${match[1]}${trailing}`;

  match = normalized.match(/^Посмотреть фильм:\s+(.+)$/i);
  if (match) return `${leading}Watch a movie: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^(режисс[её]р|акт[её]р|композитор)\s+(.+)$/i);
  if (match) {
    return `${leading}${translateKnownTerm(match[1]).toLowerCase()} ${translateKnownTerm(match[2])}${trailing}`;
  }

  match = normalized.match(/^Страна:\s+(.+)$/i);
  if (match) return `${leading}Country: ${translateKnownTerm(match[1])}${trailing}`;

  match = normalized.match(/^Известен по:\s+(.+)$/i);
  if (match) return `${leading}Known for: ${match[1]}${trailing}`;

  match = normalized.match(/^Оценили:\s+(\d+)$/i);
  if (match) return `${leading}Rated: ${match[1]}${trailing}`;

  match = normalized.match(/^без оценки:\s+(\d+)$/i);
  if (match) return `${leading}without rating: ${match[1]}${trailing}`;

  match = normalized.match(/^([+-]?\d+(?:[.,]\d+)?)\s+опыта$/i);
  if (match) return `${leading}${match[1]} XP${trailing}`;

  match = normalized.match(/^За оценку фильма «(.+)»$/i);
  if (match) return `${leading}For rating “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^За просмотр фильма «(.+)»$/i);
  if (match) return `${leading}For watching “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^За удаление оценки фильма «(.+)»$/i);
  if (match) return `${leading}For deleting the rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Оценка:\s+(.+)$/i);
  if (match) return `${leading}Rating: ${match[1]}${trailing}`;

  match = normalized.match(/^Была оценка:\s+(.+)$/i);
  if (match) return `${leading}Previous rating: ${match[1]}${trailing}`;

  match = normalized.match(/^Получено достижение «(.+)»$/i);
  if (match) return `${leading}Achievement earned: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Новое достижение:\s+(.+)$/i);
  if (match) return `${leading}New achievement: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Достижение восстановлено:\s+(.+)$/i);
  if (match) return `${leading}Achievement restored: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Выполнена карта «(.+)»$/i);
  if (match) return `${leading}Weekly card completed: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Выполнено испытание «(.+)»$/i);
  if (match) return `${leading}Challenge completed: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Просмотрен фильм «(.+)»$/i);
  if (match) return `${leading}Movie watched: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Movie watched:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Movie watched: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Rating deleted:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Rating deleted: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Rating changed:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Rating changed: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Review written:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Review written: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^For rating\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}For rating “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^For watching\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}For watching “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^For deleting the rating for\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}For deleting the rating for “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Обновил(?:а)?\s+оценку\s+фильма\s+[“"«](.+)[”"»]\s+на\s+(.+)$/i);
  if (match) return `${leading}Updated rating for “${translateTextValue(match[1], language)}” to ${match[2]}${trailing}`;

  match = normalized.match(/^Оценил(?:а)?\s+фильм\s+[“"«](.+)[”"»]\s+на\s+(.+)$/i);
  if (match) return `${leading}Rated “${translateTextValue(match[1], language)}” ${match[2]}${trailing}`;

  match = normalized.match(/^Достиг(?:ла)?\s+уровня\s+(\d+)!\s+\(\+(\d+)\s+опыта\)$/i);
  if (match) return `${leading}Reached level ${match[1]}! (+${match[2]} XP)${trailing}`;

  match = normalized.match(/^Получено\s+достижение\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Achievement earned: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Добавил(?:а)?\s+[“"«](.+)[”"»]\s+в\s+список\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Added “${translateTextValue(match[1], language)}” to “${translateTextValue(match[2], language)}”${trailing}`;

  match = normalized.match(/^Добавил(?:а)?\s+[“"«](.+)[”"»]\s+в\s+избранное$/i);
  if (match) return `${leading}Added “${translateTextValue(match[1], language)}” to favorites${trailing}`;

  match = normalized.match(/^Added to\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Added to “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Добавлено\s+в\s+«(.+)»$/i);
  if (match) return `${leading}Added to “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^(.+?):\s+зачт[её]нный фильм удал[её]н, этап снова в работе$/i);
  if (match) {
    return `${leading}${translateTextValue(match[1], language)}: counted movie was deleted, stage is active again${trailing}`;
  }

  match = normalized.match(/^(.+?):\s+удалена зачт[её]нная оценка$/i);
  if (match) {
    return `${leading}${translateTextValue(match[1], language)}: counted rating was deleted${trailing}`;
  }

  match = normalized.match(/^(.+?):\s+повторная оценка засчитана до дедлайна$/i);
  if (match) {
    return `${leading}${translateTextValue(match[1], language)}: repeated rating counted before the deadline${trailing}`;
  }

  match = normalized.match(/^Просмотрен без оценки$/i);
  if (match) return `${leading}Watched without rating${trailing}`;

  match = normalized.match(/^Изменена оценка «(.+)»$/i);
  if (match) return `${leading}Rating changed: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Удалена оценка «(.+)»$/i);
  if (match) return `${leading}Rating deleted: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Запись о просмотре удалена$/i);
  if (match) return `${leading}Watch record deleted${trailing}`;

  match = normalized.match(/^Достигнут\s+(\d+)\s+уровень$/i);
  if (match) return `${leading}Reached level ${match[1]}${trailing}`;

  match = normalized.match(/^Достигнут уровень\s+(\d+)$/i);
  if (match) return `${leading}Reached level ${match[1]}${trailing}`;

  match = normalized.match(/^Новый уровень:\s+(\d+)$/i);
  if (match) return `${leading}New level: ${match[1]}${trailing}`;

  match = normalized.match(/^(.+?)\s+добавлен(?:а)?\s+в друзья$/i);
  if (match) return `${leading}${match[1]} added as a friend${trailing}`;

  match = normalized.match(/^добавлен(?:а)?\s+в друзья$/i);
  if (match) return `${leading}added as a friend${trailing}`;

  match = normalized.match(/^Удалить\s+(.+)\s+из друзей$/i);
  if (match) return `${leading}Remove ${match[1]} from friends${trailing}`;

  match = normalized.match(/^Написана рецензия «(.+)»$/i);
  if (match) return `${leading}Review written: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^(.+?)\s+поставил(?:а)?\s+оценку$/i);
  if (match) return `${leading}${match[1]} rated a movie${trailing}`;

  match = normalized.match(/^поставил(?:а)?\s+оценку$/i);
  if (match) return `${leading}rated a movie${trailing}`;

  match = normalized.match(/^(.+?)\s+получил(?:а)?\s+уровень$/i);
  if (match) return `${leading}${match[1]} leveled up${trailing}`;

  match = normalized.match(/^получил(?:а)?\s+уровень$/i);
  if (match) return `${leading}leveled up${trailing}`;

  match = normalized.match(/^(.+?)\s+завершил(?:а)?\s+испытание$/i);
  if (match) return `${leading}${match[1]} completed a challenge${trailing}`;

  match = normalized.match(/^завершил(?:а)?\s+испытание$/i);
  if (match) return `${leading}completed a challenge${trailing}`;

  match = normalized.match(/^(.+?)\s+проходит\s+эксп[еэ]р?дицию$/i);
  if (match) return `${leading}${match[1]} is on an expedition${trailing}`;

  match = normalized.match(/^проходит\s+эксп[еэ]р?дицию$/i);
  if (match) return `${leading}is on an expedition${trailing}`;

  match = normalized.match(/^(.+?)\s+начал(?:а)?\s+карту недели$/i);
  if (match) return `${leading}${match[1]} started a weekly card${trailing}`;

  match = normalized.match(/^начал(?:а)?\s+карту недели$/i);
  if (match) return `${leading}started a weekly card${trailing}`;

  match = normalized.match(/^(.+?)\s+начал(?:а)?\s+легендарную\s+карту$/i);
  if (match) return `${leading}${match[1]} started a legendary card${trailing}`;

  match = normalized.match(/^начал(?:а)?\s+легендарную\s+карту$/i);
  if (match) return `${leading}started a legendary card${trailing}`;

  match = normalized.match(/^(.+?)\s+получил(?:а)?\s+достижение$/i);
  if (match) return `${leading}${match[1]} earned an achievement${trailing}`;

  match = normalized.match(/^получил(?:а)?\s+достижение$/i);
  if (match) return `${leading}earned an achievement${trailing}`;

  match = normalized.match(/^(.+?)\s+написал(?:а)?\s+рецензию$/i);
  if (match) return `${leading}${match[1]} wrote a review${trailing}`;

  match = normalized.match(/^написал(?:а)?\s+рецензию$/i);
  if (match) return `${leading}wrote a review${trailing}`;

  match = normalized.match(/^Испытание выполнено:\s+(.+)$/i);
  if (match) return `${leading}Challenge completed: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Challenge completed:\s+(.+)$/i);
  if (match) return `${leading}Challenge completed: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Weekly card completed:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Weekly card completed: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^Achievement earned:\s+[“"«](.+)[”"»]$/i);
  if (match) return `${leading}Achievement earned: “${translateTextValue(match[1], language)}”${trailing}`;

  match = normalized.match(/^New achievement:\s+(.+)$/i);
  if (match) return `${leading}New achievement: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Качество недели:\s+(.+)$/i);
  if (match) return `${leading}Week quality: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^(\d+)\s+фильм(?:ов|а)?\s+за\s+неделю$/i);
  if (match) return `${leading}${match[1]} ${Number(match[1]) === 1 ? "movie" : "movies"} in a week${trailing}`;

  match = normalized.match(/^(Role|Роль|Participation|Участие):\s+Не указана$/i);
  if (match) return `${leading}${translateTextValue(match[1], language)}: Not specified${trailing}`;

  match = normalized.match(/^(.+?):\s+Этап\s+(\d+)$/i);
  if (match) return `${leading}${translateKnownTerm(match[1])}: Stage ${match[2]}${trailing}`;

  match = normalized.match(/^(\d+)\s+фильмов\s+·\s+(\d+)\s+тематическ(?:ий список|их списка|их списков)$/i);
  if (match) {
    return `${leading}${match[1]} movies · ${match[2]} thematic ${Number(match[2]) === 1 ? "list" : "lists"}${trailing}`;
  }

  match = normalized.match(/^Загрузка\s+(.+?)(?:\.{3}|…)$/i);
  if (match) return `${leading}Loading ${translateTextValue(match[1], language).toLowerCase()}...${trailing}`;

  match = normalized.match(/^Загружаем страницу\s+(\d+)$/i);
  if (match) return `${leading}Loading page ${match[1]}${trailing}`;

  match = normalized.match(/^Оценка и запись просмотра «(.+)» будут удалены из вашей статистики\.$/i);
  if (match) {
    return `${leading}The rating and watch record for “${match[1]}” will be removed from your statistics.${trailing}`;
  }

  match = normalized.match(/^Фильмов с оценкой\s+(.+)$/i);
  if (match) return `${leading}Movies rated ${match[1]}${trailing}`;

  match = normalized.match(/^(\d{4})\s+год$/i);
  if (match) return `${leading}${match[1]}${trailing}`;

  match = normalized.match(/^(\d{4})-е$/i);
  if (match) return `${leading}${match[1]}s${trailing}`;

  match = normalized.match(/^(.+?)\s+·\s+(\d+)\s+фильмов\s+за\s+день$/i);
  if (match) return `${leading}${match[1]} · ${match[2]} movies in a day${trailing}`;

  match = normalized.match(/^(\d+)\s+фильмов\s+за\s+день$/i);
  if (match) return `${leading}${match[1]} movies in a day${trailing}`;

  match = normalized.match(/^(.+?)\s+·\s+(\d+)\s+мин\.?$/i);
  if (match) return `${leading}${match[1]} · ${match[2]} min${trailing}`;

  match = normalized.match(/^(.+?)\s+·\s+([+-]?\d+(?:[.,]\d+)?)\s+ч$/i);
  if (match) return `${leading}${match[1]} · ${match[2]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+мин\.?$/i);
  if (match) return `${leading}${match[1]} min${trailing}`;

  match = normalized.match(/^([+-]?\d+(?:[.,]\d+)?)\s+ч$/i);
  if (match) return `${leading}${match[1]} h${trailing}`;

  match = normalized.match(/^([+-]?\d+(?:[.,]\d+)?)\s+дн\.$/i);
  if (match) return `${leading}${match[1]} d${trailing}`;

  match = normalized.match(/^([+-]?\d+(?:[.,]\d+)?)\s+дн$/i);
  if (match) return `${leading}${match[1]} d${trailing}`;

  match = normalized.match(/^(\d+)\s+д(?:ень|ня|ней)$/i);
  if (match) return `${leading}${match[1]} ${Number(match[1]) === 1 ? "day" : "days"}${trailing}`;

  match = normalized.match(/^(\d+)\s+дн\.\s+(\d+)\s+ч\.$/i);
  if (match) return `${leading}${match[1]} d ${match[2]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+дн\.\s+(\d+)\s+ч\.?$/i);
  if (match) return `${leading}${match[1]} d ${match[2]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+д\.\s+(\d+)\s+ч\.$/i);
  if (match) return `${leading}${match[1]} d ${match[2]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+д\.\s+(\d+)\s+ч\.?$/i);
  if (match) return `${leading}${match[1]} d ${match[2]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+д\.$/i);
  if (match) return `${leading}${match[1]} d${trailing}`;

  match = normalized.match(/^(\d+)\s+д\.?$/i);
  if (match) return `${leading}${match[1]} d${trailing}`;

  match = normalized.match(/^(\d+)\s+ч\.\s+(\d+)\s+мин\.$/i);
  if (match) return `${leading}${match[1]} h ${match[2]} min${trailing}`;

  match = normalized.match(/^(\d+)\s+ч\.\s+(\d+)\s+мин\.?$/i);
  if (match) return `${leading}${match[1]} h ${match[2]} min${trailing}`;

  match = normalized.match(/^(\d+)\s+ч\.$/i);
  if (match) return `${leading}${match[1]} h${trailing}`;

  match = normalized.match(/^(\d+)\s+ч\.?$/i);
  if (match) return `${leading}${match[1]} h${trailing}`;

  match = normalized.match(/^([+-]?\d+(?:[.,]\d+)?)\s+нед\.$/i);
  if (match) return `${leading}${match[1]} wk${trailing}`;

  match = normalized.match(/^(Этап 1|Этап 2|Финальный этап|Финал)\.\s+(.+)$/i);
  if (match) return `${leading}${translateTextValue(match[1], language)}. ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Осталось\s+(.+)$/i);
  if (match) return `${leading}Remaining ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^(\d+)\/(\d+)\s+активных$/i);
  if (match) return `${leading}${match[1]}/${match[2]} active${trailing}`;

  match = normalized.match(/^(\d+)\/(\d+)\s+открыто$/i);
  if (match) return `${leading}${match[1]}/${match[2]} opened${trailing}`;

  match = normalized.match(/^(\d+)\/(\d+)\s+выбрано$/i);
  if (match) return `${leading}${match[1]}/${match[2]} selected${trailing}`;

  match = normalized.match(/^Прогресс:?\s+(\d+)\s+из\s+(\d+)$/i);
  if (match) return `${leading}Progress: ${match[1]} of ${match[2]}${trailing}`;

  match = normalized.match(/^Оценили\s+(\d+)\s+фильм(?:ов|а)?$/i);
  if (match) return `${leading}Rated ${match[1]} movies${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} ${Number(match[1]) === 1 ? "movie" : "movies"}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+фильм(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} ${Number(match[1]) === 1 ? "movie" : "movies"}${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+разных?\s+жанр(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} different genres${trailing}`;

  match = normalized.match(/^Посмотреть кино из\s+(\d+)\s+разных?\s+десятилет(?:ий|ия)$/i);
  if (match) return `${leading}Watch movies from ${match[1]} different decades${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+с\s+одним\s+акт[её]ром$/i);
  if (match) return `${leading}Watch ${match[1]} movies with one actor${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+одного\s+режисс[её]ра$/i);
  if (match) return `${leading}Watch ${match[1]} movies by one director${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+одного\s+композитора$/i);
  if (match) return `${leading}Watch ${match[1]} movies by one composer${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+одного\s+жанра$/i);
  if (match) return `${leading}Watch ${match[1]} movies from one genre${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+одного\s+режисс[её]ра\s+за\s+(\d+)\s+недел(?:и|ь)$/i);
  if (match) return `${leading}Watch ${match[1]} movies by one director in ${match[2]} weeks${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+за\s+(\d+)\s+недел(?:и|ь)$/i);
  if (match) return `${leading}Watch ${match[1]} movies in ${match[2]} weeks${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+за\s+короткий\s+срок$/i);
  if (match) return `${leading}Watch ${match[1]} movies in a short period${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies from ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+фильм(?:а|ов)?\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies from ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+фильмы\s+из\s+(\d+)\s+стран\s+(.+)$/i);
  if (match) return `${leading}Watch movies from ${match[1]} countries in ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+фильмы\s+на\s+(\d+)\s+язык(?:ах|а)?\s+оригинала$/i);
  if (match) return `${leading}Watch movies in ${match[1]} original languages${trailing}`;

  match = normalized.match(/^Посмотреть\s+фильм\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch a movie from ${translateKnownTerm(match[1])}${trailing}`;

  match = normalized.match(/^Посмотрите\s+фильм\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch a movie from ${translateKnownTerm(match[1])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+фильм\s+(.+)$/i);
  if (match) return `${leading}Watch a movie ${translateKnownTerm(match[1])}${trailing}`;

  match = normalized.match(/^Посмотрите\s+фильм\s+(.+)$/i);
  if (match) return `${leading}Watch a movie ${translateKnownTerm(match[1])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+(.+?)\s+фильм(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} ${translateKnownTerm(match[2])} movies${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+(.+?)\s+фильм(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} ${translateKnownTerm(match[2])} movies${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+сериал(?:а|ов)?\s+или\s+сезон(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} series or seasons${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+полнометражных?\s+фильм(?:а|ов)?$/i);
  if (match) return `${leading}Watch ${match[1]} feature films${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+не\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies not from ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+фильм(?:а|ов)?\s+не\s+из\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies not from ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+фильм(?:а|ов)?\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+фильм(?:а|ов)?\s+(.+)$/i);
  if (match) return `${leading}Watch ${match[1]} movies ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Посмотреть\s+(драму|комедию)$/i);
  if (match) return `${leading}Watch a ${translateKnownTerm(match[1]).toLowerCase()}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(драму|комедию)$/i);
  if (match) return `${leading}Watch a ${translateKnownTerm(match[1]).toLowerCase()}${trailing}`;

  match = normalized.match(/^Посмотреть\s+(\d+)\s+(триллер(?:а|ов)?|хоррор(?:а|ов)?|драм|комеди(?:и|й)|мультфильм(?:а|ов)?)$/i);
  if (match) return `${leading}Watch ${match[1]} ${translateKnownTerm(match[2]).toLowerCase()}${trailing}`;

  match = normalized.match(/^Посмотрите\s+(\d+)\s+(триллер(?:а|ов)?|хоррор(?:а|ов)?|драм|комеди(?:и|й)|мультфильм(?:а|ов)?)$/i);
  if (match) return `${leading}Watch ${match[1]} ${translateKnownTerm(match[2]).toLowerCase()}${trailing}`;

  match = normalized.match(/^Поставить\s+(\d+)\s+оцен(?:ки|ок|ку)\s+(.+)$/i);
  if (match) return `${leading}Give ${match[1]} ratings of ${match[2]}${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+страну$/i);
  if (match) return `${leading}Discover ${match[1]} ${Number(match[1]) === 1 ? "country" : "countries"}${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+нов(?:ые|ых|ую)\s+стран(?:ы|у)?$/i);
  if (match) return `${leading}Discover ${match[1]} new countries${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+стран(?:ы)?$/i);
  if (match) return `${leading}Discover ${match[1]} countries${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+стран\s+и\s+территор(?:ий|ии)$/i);
  if (match) return `${leading}Discover ${match[1]} countries and territories${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+стран\s+(.+)$/i);
  if (match) return `${leading}Discover ${match[1]} countries in ${translateKnownTerm(match[2])}${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+разных?\s+жанр(?:а|ов)?$/i);
  if (match) return `${leading}Discover ${match[1]} different genres${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+разных?\s+десятилет(?:ий|ия)$/i);
  if (match) return `${leading}Discover ${match[1]} different decades${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+десятилет(?:ий|ия)$/i);
  if (match) return `${leading}Discover ${match[1]} decades${trailing}`;

  match = normalized.match(/^Открыть\s+(\d+)\s+разных?\s+год(?:ов)?\s+выпуска$/i);
  if (match) return `${leading}Discover ${match[1]} different release years${trailing}`;

  match = normalized.match(/^Закрыть\s+(.+)$/i);
  if (match) return `${leading}Complete ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Набрать\s+(\d+)\s+час(?:ов|а)?\s+просмотра$/i);
  if (match) return `${leading}Watch ${match[1]} hours${trailing}`;

  match = normalized.match(/^Смотреть фильмы в\s+(\d+)\s+разных?\s+дн(?:ях|я|ей)$/i);
  if (match) return `${leading}Watch movies on ${match[1]} different days${trailing}`;

  match = normalized.match(/^(\d+)\s+час(?:ов|а)?\s+кино$/i);
  if (match) return `${leading}${match[1]} hours of cinema${trailing}`;

  match = normalized.match(/^(\d+)\s+(золотых|платиновых|алмазных|легендарных)\s+недель$/i);
  if (match) return `${leading}${match[1]} ${translateKnownTerm(match[2])} weeks${trailing}`;

  match = normalized.match(/^(\d+)\s+недель\s+с\s+(\d+)\+\s+фильм(?:ами|ом)$/i);
  if (match) return `${leading}${match[1]} weeks with ${match[2]}+ movies${trailing}`;

  match = normalized.match(/^Слайд\s+(\d+)\s+из\s+(\d+)$/i);
  if (match) return `${leading}Slide ${match[1]} of ${match[2]}${trailing}`;

  match = normalized.match(/^Перейти к слайду\s+(\d+)$/i);
  if (match) return `${leading}Go to slide ${match[1]}${trailing}`;

  match = normalized.match(/^Поставить оценку\s+(.+)$/i);
  if (match) return `${leading}Set rating ${match[1]}${trailing}`;

  match = normalized.match(/^Письмо для смены пароля отправлено на\s+(.+)$/i);
  if (match) return `${leading}Password reset email sent to ${match[1]}${trailing}`;

  match = normalized.match(/^Импортировано\s+(\d+)%$/i);
  if (match) return `${leading}${match[1]}% imported${trailing}`;

  match = normalized.match(/^(Не перенесено|Пропущено при чтении|Новые достижения|Новые уровни|Всего к импорту|Найдено для импорта):\s+(\d+)$/i);
  if (match) return `${leading}${translateTextValue(`${match[1]}:`, language)} ${match[2]}${trailing}`;

  match = normalized.match(/^Сейчас:\s+(.+)$/i);
  if (match) return `${leading}Now: ${match[1]}${trailing}`;

  match = normalized.match(/^Обработка:\s+(.+)$/i);
  if (match) return `${leading}Processing: ${match[1]}${trailing}`;

  match = normalized.match(/^(Определ[её]н файл (?:со списками|с оценками))\.\s+Найдено строк:\s+(\d+)$/i);
  if (match) return `${leading}${translateTextValue(match[1], language)}. Rows found: ${match[2]}${trailing}`;

  match = normalized.match(/^Импорт остановлен:\s+(.+)$/i);
  if (match) return `${leading}Import stopped: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^«(.+)»\s+будет удал[её]н\s+из\s+списка\s+«(.+)»\.$/i);
  if (match) return `${leading}“${match[1]}” will be removed from “${translateTextValue(match[2], language)}”.${trailing}`;

  match = normalized.match(/^Удалить пользователя\s+(.+)\s+из друзей\?$/i);
  if (match) return `${leading}Remove ${match[1]} from friends?${trailing}`;

  match = normalized.match(/^Хотите добавить пользователя\s+(.+)\s+в друзья\?$/i);
  if (match) return `${leading}Add ${match[1]} as a friend?${trailing}`;

  match = normalized.match(/^Пользователь\s+(.+)\s+добавлен\s+в\s+список\s+друзей!?$/i);
  if (match) return `${leading}User ${match[1]} added to friends${trailing}`;

  match = normalized.match(/^Просмотрено фильмов\s+-\s+(.+)$/i);
  if (match) return `${leading}Movies watched - ${match[1]}${trailing}`;

  match = normalized.match(/^Друзей\s+-\s+(.+)$/i);
  if (match) return `${leading}Friends - ${match[1]}${trailing}`;

  match = normalized.match(/^Всего опыта:\s+(.+)$/i);
  if (match) return `${leading}Total XP: ${match[1]}${trailing}`;

  match = normalized.match(/^Рекомендован по фильму «(.+)» — ваша оценка\s+(.+)$/i);
  if (match) return `${leading}Recommended because of “${translateKnownTerm(match[1])}” — your rating ${match[2]}${trailing}`;

  match = normalized.match(/^Найден среди похожих на «(.+)» — ваша оценка\s+(.+)$/i);
  if (match) return `${leading}Found among movies similar to “${translateKnownTerm(match[1])}” — your rating ${match[2]}${trailing}`;

  match = normalized.match(/^Из той же серии, что «(.+)»$/i);
  if (match) return `${leading}From the same collection as “${translateKnownTerm(match[1])}”${trailing}`;

  match = normalized.match(/^Тот же режисс[её]р, что у «(.+)»:\s+(.+)$/i);
  if (match) return `${leading}Same director as “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Общие темы с «(.+)»:\s+(.+)$/i);
  if (match) return `${leading}Shared themes with “${translateKnownTerm(match[1])}”: ${translateKnownTermList(match[2]) || match[2]}${trailing}`;

  match = normalized.match(/^Похож(?:ее|е)\s+сочетание жанров:\s+(.+)$/i);
  if (match) return `${leading}Similar genre mix: ${translateKnownTermList(match[1]) || match[1].split(/\s*,\s*/).map(translateKnownTerm).join(", ")}${trailing}`;

  match = normalized.match(/^Знакомые актёры из «(.+)»:\s+(.+)$/i);
  if (match) return `${leading}Familiar actors from “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Знакомые актеры из «(.+)»:\s+(.+)$/i);
  if (match) return `${leading}Familiar actors from “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Общий автор с «(.+)»:\s+(.+)$/i);
  if (match) return `${leading}Shared creator with “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Вы высоко оценивали фильмы режисс[её]ра\s+(.+)$/i);
  if (match) return `${leading}You rated this director’s films highly: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^В ваших оценках 8–10 совпадают темы:\s+(.+)$/i);
  if (match) return `${leading}Themes from your 8–10 ratings: ${translateKnownTermList(match[1]) || match[1]}${trailing}`;

  match = normalized.match(/^Вы высоко оценивали работы автора\s+(.+)$/i);
  if (match) return `${leading}You rated this writer’s work highly: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Вы высоко оценивали фильмы с акт[её]рами\s+(.+)$/i);
  if (match) return `${leading}You rated movies with these actors highly: ${translateTextValue(match[1], language)}${trailing}`;

  match = normalized.match(/^Совпало сочетание любимых жанров:\s+(.+)$/i);
  if (match) return `${leading}Favorite genre mix matched: ${translateKnownTermList(match[1]) || match[1].split(/\s*,\s*/).map(translateKnownTerm).join(", ")}${trailing}`;

  match = normalized.match(/^Recommended because of [“"«](.+)[”"»]\s+—\s+your rating\s+(.+)$/i);
  if (match) return `${leading}Recommended because of “${translateKnownTerm(match[1])}” — your rating ${match[2]}${trailing}`;

  match = normalized.match(/^Found among movies similar to [“"«](.+)[”"»]\s+—\s+your rating\s+(.+)$/i);
  if (match) return `${leading}Found among movies similar to “${translateKnownTerm(match[1])}” — your rating ${match[2]}${trailing}`;

  match = normalized.match(/^Shared themes with [“"«](.+)[”"»]:\s+(.+)$/i);
  if (match) return `${leading}Shared themes with “${translateKnownTerm(match[1])}”: ${translateKnownTermList(match[2]) || match[2]}${trailing}`;

  match = normalized.match(/^Shared creator with [“"«](.+)[”"»]:\s+(.+)$/i);
  if (match) return `${leading}Shared creator with “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Familiar actors from [“"«](.+)[”"»]:\s+(.+)$/i);
  if (match) return `${leading}Familiar actors from “${translateKnownTerm(match[1])}”: ${translateTextValue(match[2], language)}${trailing}`;

  match = normalized.match(/^Similar genre mix:\s+(.+)$/i);
  if (match) return `${leading}Similar genre mix: ${translateKnownTermList(match[1]) || match[1].split(/\s*,\s*/).map(translateKnownTerm).join(", ")}${trailing}`;

  match = normalized.match(/^(Железная|Бронзовая|Серебряная|Золотая|Платиновая|Алмазная|Легендарная):\s*(\d+)$/i);
  if (match) {
    return `${leading}${translateTextValue(match[1], language)}: ${match[2]}${trailing}`;
  }

  if (/(Железная|Бронзовая|Серебряная|Золотая|Платиновая|Алмазная|Легендарная):\s*\d+/i.test(normalized)) {
    const translated = normalized.replace(
      /(Железная|Бронзовая|Серебряная|Золотая|Платиновая|Алмазная|Легендарная):\s*(\d+)/gi,
      (_value, rank: string, count: string) => `${translateTextValue(rank, language)}: ${count}`
    );
    return `${leading}${translated}${trailing}`;
  }

  match = normalized.match(/^(легендарная|эпическая|редкая|обычная):\s*(\d+)$/i);
  if (match) {
    const rank = UI_TRANSLATIONS.en[match[1].toLowerCase()] || match[1];
    return `${leading}${rank}: ${match[2]}${trailing}`;
  }

  if (/(легендарная|эпическая|редкая|обычная):\s*\d+/i.test(normalized)) {
    const translated = normalized
      .replace(/легендарная/gi, "legendary")
      .replace(/эпическая/gi, "epic")
      .replace(/редкая/gi, "rare")
      .replace(/обычная/gi, "common");
    return `${leading}${translated}${trailing}`;
  }

  return value;
};

export const t: typeof translateTextValue = translateTextValue;
